export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XXI N⁰. 112",
    "shortTitle": "",
    "description": "",
    "width": 1532,
    "height": 1149,
    "currentLanguage": "FR",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "http://escrime-xxi.fie.org/112/en"
    },{
      "code": "FR",
      "text": "French",
      "href": "http://escrime-xxi.fie.org/112/fr"
    },{
      "code": "ES",
      "text": "Spanish",
      "href": "http://escrime-xxi.fie.org/112/es"
    }],
    "basePath": "/112/fr",
    "companyLogo": "1-numeral.png",
    "publishURL": "http://escrime-xxi.fie.org/112/fr/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "mobileSwitch": true,
      "guideEnabled": false,
      "galleryCaptions": {},
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `

        <img id="1-0" class="halfScale" style="top:1px;left:371px" src="/112/fr/static/_content/1-numeral.png">
        
        <img id="1-1" class="halfScale" style="top:98px;left:55px" src="/112/fr/static/_content/1-title.png">
        <img id="1-2" class="halfScale" style="top:276px;left:68px" src="/112/fr/static/_content/1-sub-1.png">

        <img id="1-3" class="halfScale" style="top:111px;left:1076px" src="/112/fr/static/_content/1-issue.png">

        <img id="1-text-1" class="halfScaleR pointer" style="top:352px;right:0px" onclick="Publish.goToPage(19)" src="/112/fr/static/_content/1-sub-2.png">
        <img id="1-text-2" class="halfScaleR pointer" style="top:517px;right:0px" onclick="Publish.goToPage(8)" src="/112/fr/static/_content/1-sub-3.png">
        <img id="1-text-3" class="halfScaleR pointer" style="top:730px;right:0px" onclick="Publish.goToPage(16)" src="/112/fr/static/_content/1-sub-4.png">

        <img id="1-4" class="halfScale pointer" style="top:988px;left:1442px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/1-arrow.png">

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
          .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
          .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
          .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-3"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-text-1"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-2"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-text-3"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-4"), 0.5, {x:-60, opacity:0}, {x:0, opacity:1})
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "N˚112 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  JOURNÉE MONDIALE DE L’ESCRIME L’ESCRIME VÉTÉRAN AU CAIRE SOFYA VELIKAYA RETOUR AU SOMMET  Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine",
      "mobileHtml": `
      
      <img src="/112/fr/static/_mobile/pg1.jpg">

      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

      <img class="halfScale 2-title" style="top:103px;left:78px" src="/112/fr/static/_content/2-title.png">

      <img class="halfScale 2-icons" style="top:863px;left:153px" src="/112/fr/static/_content/2-pop.png">
      <img class="halfScale 2-icons" style="top:864px;left:453px" src="/112/fr/static/_content/2-play.png">
      <img class="halfScale 2-icons" style="top:864px;left:801px" src="/112/fr/static/_content/2-soc.png">
      <img class="halfScale 2-icons" style="top:864px;left:1152px" src="/112/fr/static/_content/2-no.png">

      <img class="halfScale pointer howto-desktop" style="top:125px;left:1071px;opacity:1;" onclick="switchPopHowto(true)" src="/112/fr/static/_content/2-desktop-btn.png">
      <img class="halfScale pointer howto-ipad" style="top:125px;left:1271px;opacity:0" onclick="switchPopHowto(false)" src="/112/fr/static/_content/2-ipad-btn.png">

      <img class="halfScale howto-desktop" style="top:257px;left:72px;" src="/112/fr/static/_content/2-desktop.png">
      <img class="halfScale howto-ipad" style="top:247px;left:86px;display:none;" src="/112/fr/static/_content/2-ipad.png">

      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": ` 
        function onPageEnter() {
          pg2Anim = new TimelineMax()
          pg2Anim.fromTo(cOf("2-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .staggerFromTo(cOf("2-icons"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, "-=0.2")
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "C OMMENT NAVIGUER  Cliquez pour changer d’affichage  COMMENT NAVIGUER  IPAD  BUREAU  Escrime XXI Le magazine de l’escrime utilise les toutes dernières technologies numériques. Voici quelques-unes de ses caractéristiques les plus séduisantes.  NAVIGATION Utilisez les flèches de votre pavé numérique pour vous déplacer horizontalement à travers le magazine.  Navigation Pour voir le magazine, utilisez les flèches de votre pavé numérique pour naviguer horizontalement.  BROWSER Pour de meilleurs résultats, nous recommandons d’utiliser les navigateurs Safari ou Google Chrome.  EXPLOREZ  térieur ! Des articles passionnants à l’in  1 2 3 FENÊTRES CONTEXTUELLES  BOUTON DE LECTURE  MÉDIAS SOCIAUX  NOMBRES  Appuyez pour faire surgir des trésors d’information.  Ce magazine propose de superbes vidéos, que l’on peut voir en appuyant sur ce bouton.  Appuyez sur les icones des réseaux sociaux que vous rencontrerez tout au long du magazine.  Appuyez sur les boutons pour dévoiler plus de contenus passionnants.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
          <a href="http://www.tissotwatches.com" target="_blank">
            <div class="contentLinkNone" style="bottom:24px;right:40px;width:280px; height:30px;"></div>
          </a>`,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml":`
      
      <a href="http://www.tissotwatches.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg3.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `

        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" style="top: 191px; left:80px;width:145px; height: 35px;">
          <a href="http://www.fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top: 75px; right:623px;width:55px; height: 55px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top:130px; right:623px;width:55px; height: 55px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div> 

        <img id="4-title" class="halfScale" style="top:63px;left:86px" src="/112/fr/static/_content/4-title.png">

        <img id="fourIpad" class="cont-item-0-link halfScale" style="top:386px;left:591px" src="/112/fr/static/_content/4-ipad.png">
        <img class="cont-item cont-item-1-btn halfScale" style="top:327px;left:573px;opacity:0" src="/112/fr/static/_content/4-editorial.png">
        <img class="cont-item cont-item-2-btn halfScale" style="top:338px;left:574px;opacity:0" src="/112/fr/static/_content/4-sport.png">
        <img class="cont-item cont-item-3-btn halfScale" style="top:358px;left:573px;opacity:0" src="/112/fr/static/_content/4-interview.png">
        <img class="cont-item cont-item-4-btn halfScale" style="top:351px;left:573px;opacity:0" src="/112/fr/static/_content/4-fie.png">
        <img class="cont-item cont-item-5-btn halfScale" style="top:327px;left:574px;opacity:0" src="/112/fr/static/_content/4-news.png">
        <img class="cont-item cont-item-6-btn halfScale" style="top:358px;left:574px;opacity:0" src="/112/fr/static/_content/4-obit.png">

        <img id="4-next" class="halfScale pointer" style="top:940px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/4-arrow.png">

        <div class="addContentLink" onclick="contentsBub(1);" style="top:358px; left:84px; width: 492px; height: 60px;"></div> 
        <div class="addContentLink" onclick="contentsBub(2);" style="top:450px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(3);" style="top:543px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(4);" style="top:635px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top:727px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top:819px; left:84px; width: 492px; height: 60px;"></div>

        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:357px;left:577px;width:638px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:358px;left:651px;width:716px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(11)" style="top:450px;left:575px;width:792px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(16)" style="top:541px;left:574px;width:597px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(19)" style="top:357px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(23)" style="top:449px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(27)" style="top:540px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(30)" style="top:633px;left:573px;width:758px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(33)" style="top:725px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(36)" style="top:816px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-1');}, 200)" style="top:450px;left:649px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-2');}, 200)" style="top:541px;left:649px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-3');}, 200)" style="top:632px;left:649px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-4');}, 200)" style="top:726px;left:574px;width:780px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-5');}, 200)" style="top:817px;left:649px;width:706px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-1', '43-btn-1');}, 200)" style="top:634px;left:584px;width:413px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-2', '43-btn-2');}, 200)" style="top:726px;left:584px;width:413px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-3', '43-btn-3');}, 200)" style="top:818px;left:574px;width:424px;height:64px;display:none;"></div>
      `,
      "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        
        pg4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
        .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
  
  
      function contentsBub(index){
        TweenMax.to(cOf("cont-hide"), 0.5, {opacity:0})
        console.log("contentsBub", index)
        for(var i=0; i <= 6; i++){
          if(i == index){
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
              console.log(c)
              c.style.display = "";
            },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
              
              classc("cont-item-"+index+"-link")[0].style.display = ""
              if(classc("cont-item-"+index+"-link")[1]){
                classc("cont-item-"+index+"-link")[1].style.display = "" 
              }
            }});
          }else{
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});
            TweenMax.to(idOf("fourIpad"), 0.5, {opacity:0});
          }
        }
      }
  
      function onPageLeave() {
        pg4Anim.stop()
        removeContentLinks();
        contentsBub(0);
        TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});
      }
      `,
      "searchText": "SOMMAIRE  DANS CE NUMÉRO WWW.FIE.ORG  Bienvenue dans la dernière édition d’Escrime XXI, proposant les meilleures images, vidéos et articles sur l’escrime, le tout dans une éblouissante nouvelle maquette.  ÉDITORIAL  SPORT  Cliquez pour faire apparaître les détails  INTERVIEW ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES  ACTUALITÉS  NÉCROLOGIE  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

      <img class="halfScale pointer 5-arrow" style="top:854px;left:1387px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/5-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:54px" src="/112/fr/static/_content/5-social-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:124px" src="/112/fr/static/_content/5-social-fb.png">
      </a>
      <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1013px;left:192px" src="/112/fr/static/_content/5-social-yt.png">
      </a>

      <div class="addContentLink" style="bottom:242px;left:745px;width:100px;height:26px;">
        <a href="mailto:info@fie.ch"></a>
      </div>
        <div class="addContentLink" style="bottom:213px;left:686px;width:105px;height:26px;">
          <a href="http://www.fie.org" target="_blank"></a>
      </div>
        <div class="addContentLink" style="bottom:127px;right:332px;width:193px;height:30px;">
          <a href="http://www.touchline.com" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax()
          pg5Anim.fromTo(cOf("5-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "C OMITÉ E XÉCUTIF DE L A FIE  Président: Alisher Usmanov (RUS) Secrétaire Général: Emmanuel Katsiadakis (M.H.) (GRE) Secrétaire Trésorier: Ferial Nadira Salhi (ALG)  SIÈGE DE LA FIE Directrice générale Nathalie Rodriguez M.-H. (FRA)  Vice-Présidents: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Membres: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Wei Wang (CHN) Aldo Montano Président de la Commission des Athlètes de la FIE (ITA)  Administration Directrice administrative: Elena Murdaca (ITA) Directrice de la comptabilité: Sandra Baroni (SUI) Assistante de la directrice: Gabrielle Meylan (BRA) Assistante administrative: Ylenia Murdaca (ITA) Directrice d’opérations: Elena Huot (RUS)  Président de la Confédération Africaine d’Escrime: Mbagnick Ndiaye (SEN) Président de la Confédération Panaméricaine d’Escrime: Vitaly Logvin (MEX) Président de la Confédération Asiatique d’Escrime: Celso L. Dayrit (M.H.) (PHI) Président de la Confédération Européenne d’Escrime: Stanislav Pozdnyakov (RUS) Président de la Confédération Océanique d’Escrime: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tél. : +41 21 320 31 15 Fax : +41 21 320 31 16 e-mail : info@fie.ch www.fie.org  Sport Directeur sport et technique: Evgeny Tsoukhlo (RUS) Manager de la technologie et de l’administration du sport: Natalia Bodrova (RUS) Manager des operations sportives: Sophie Treyvaud (SUI) Communication, Marketing, TV Chef du cabinet du Président : Nina Lalovic (SRB) Manager digital et communication: Maria Ntanou (GRE) Responsable de la production télévisuelle de la FIE: Barna Heder (HUN) Assistante du responsable de la production télévisuelle de la FIE: Svetlana Krasnokoutskaya (RUS) Attaché de presse: Serge Timacheff (USA) Photographie: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
      "mobileHtml": `
      <p>
      <b>President</b>:<br> Alisher Usmanov (RUS)<br>
      <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
      <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>
      <p>
      <b>Vice Presidents</b>:<br>
      Ana Pascu (M.H.) (ROU)<br>
      Donald Anthony (USA)<br>
      Yuki Ota (JPN)<br></p>
      <p>
      <b>Members</b>:<br>
      Erika Aze (LAT)<br>
      Jacek Bierkowski (POL)<br>
      Velichka Hristeva (BUL)<br>
      Isabelle Lamour (FRA)<br>
      Novak Perovic (RSA)<br>
      Oleg Peskov (KAZ)<br>
      Giorgio Scarso (ITA)<br>
      Bence Szabo (HUN)<br>
      Pascal Tesch (LUX)<br>
      Wei WANG (CHN)<br>
      Aldo Montano President of the FIE athletes commission (ITA)<br></p>

      <p>
        <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>
        <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>
        <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
        <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>
        <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>
      </p>
      
      <h2>FIE Head Office</h2>
      <p>
      <b>Chief Executive Officer</b><br>
      Nathalie Rodriguez M.-H. (FRA)
      </p>

      <h2>Administration</h2>
      <p>
      <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>
      <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>
      <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>
      <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>
      <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>
      </p>

      <h2>Sport</h2>
      <p>
      <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>
      <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>
      <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>
      </p>
      <h2>Communication, Marketing, TV</h2>
      <p>
      <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>
      <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>
      <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>
      <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
      <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>
      <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>
      </p>

      <h2>Design</h2>
      <p>
      Touchline </b><br>
      (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
      </p>
    `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

      <a href="https://tokyo2020.fie.org/qualification" target="_blank">
          <div class="contentLinkNone fw-pg-2" style="display:none; z-index: 999; bottom:234px;right:787px;width:430px; height:30px;"></div>
      </a>

        <img id="6-img" class="halfScale" style="top:338px;left:459px" src="/112/fr/static/_content/6-img.jpg">
        <img id="6-title" class="halfScale" style="top:721px;left:91px" src="/112/fr/static/_content/6-title.png">

        <img id="6-text-1" class="halfScale" style="top:340px;left:784px" src="/112/fr/static/_content/6-text-1.png">
        <img id="6-text-2" class="halfScale" style="top:338px;left:201px; opacity:0;" src="/112/fr/static/_content/6-text-2.png">

        <img id="6-cta-1" class="halfScale pointer" style="top:819px;left:783px" onclick="toggleText6(false);" src="/112/fr/static/_content/6-page-1.jpg">
        <img id="6-cta-2" class="halfScale pointer" style="top:819px;left:1062px;opacity:0" onclick="toggleText6(true);" src="/112/fr/static/_content/6-page-2.jpg">

        <img id="6-next" class="halfScale pointer" style="top:938px;left:1387px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/6-arrow.jpg">
      `,
      "script": `
      function onPageEnter(){
        pg6Anim = new TimelineMax();
        pg6Anim.fromTo(idOf("6-img"), 0.5,{opacity:0}, {opacity:1},0.5)
            .fromTo(idOf("6-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
            .fromTo(idOf("6-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
      }

      function toggleText6(bool){
        var text1 = idOf("6-text-1");
        var text2 = idOf("6-text-2");
        
        if(!bool && text1.style.opacity == "0"){
          pg6Anim.play();
          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
        }else if(bool && text2.style.opacity == "0"){
          pg6Anim.pause();
          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
          cOf("fw-pg-2")[0].style.display = 'block';
        }
      }

      function onPageLeave(){
        if(idOf("6-text-1").style.opacity == "0"){
          toggleText6(false);
        }
        pg6Anim.stop();
        removeContentLinks()
      }
      `,
      "searchText": "SOMMAIRE  Chers amis,  L’ESCRIME POUR UNE PLANÈTE PLUS PROPRE ET VERTE  Après une saison 2019 très réussie et l’effervescence des Championnats du monde de Budapest, nous avons mis le cap sur une grande célébration de la Journée mondiale de l’escrime en septembre. Nos tireurs, clubs d’escrime et fédérations se sont mobilisés dans 153 pays pour faire découvrir notre sport et plus important encore, pour mettre leurs talents et leur dévouement envers le sport au service de l’épanouissement de leurs communautés et de l’amélioration de notre environnement commun.  PAGE 1  PAGE 2  W W W.FIE .ORG",
      "mobileHtml": `
      
      

      

      

      

      

      <img id="fwdimg" src="/112/fr/static/_mobile/6-img.jpg">
      <p>Après une saison 2019 très réussie et l'effervescence des Championnats du monde de Budapest, nous avons mis le cap sur une grande célébration de la Journée mondiale de l'escrime en septembre. Nos tireurs, clubs d'escrime et fédérations se sont mobilisés dans 153 pays pour faire découvrir notre sport et plus important encore, pour mettre leurs talents et leur dévouement envers le sport au service de l'épanouissement de leurs communautés et de l'amélioration de notre environnement commun.</p>
      <p>Le mois d'octobre a été marqué par un autre grand événement de l'escrime, réservé cette fois à nos tireurs les plus âgés : les Championnats du monde d'escrime vétérans 2019 au Caire. Vingt-quatre épreuves dans trois catégories d'âge (50+, 60+ et 70+) ont ainsi été disputées par 699 athlètes des cinq continents et rediffusées intégralement en direct sur Internet pour la toute première fois.</p>
      <p>Vingt-six compétitions satellites avec un très bon taux de participation ont déjà été organisées au cours de cette période automnale pour préparer la saison senior. Tous nos athlètes ont aujourd'hui les yeux rivés sur Tokyo 2020 et notre processus de qualification olympique qui se terminera en avril prochain et que vous pouvez découvrir sur notre portail « Tokyo Loves Fencing » à l'adresse https://tokyo2020.fie.org/qualification.</p>
      <p>Le voyage se poursuit avec l'ouverture prochaine de cette saison olympique par la Coupe du monde d'épée féminine de Tallinn en Estonie. Avec un enjeu de taille, 284 tireurs inscrits en individuel et 29 équipes en lice, cette compétition donne le coup d'envoi d'une autre grande saison d'escrime internationale.</p>
      <p>Je vous remercie de votre participation et de votre soutien à la FIE, et de faire partie de notre communauté de l'escrime véritablement mondiale. </p>
      <br>
      <p>Alisher Usmanov</p>
      <p><strong>Président de la FIE</strong></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top:962px;left:769px;width:719px; height:54px;">
          <a href="http://www.absolutefencinggear.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml":`
      
      <a href="http://www.absolutefencinggear.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg7.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 8-title" style="top:125px;left:350px" src="/112/fr/static/_content/8-title.png">

      <img class="halfScale 8-line" style="top:307px;left:869px" src="/112/fr/static/_content/8-line.png">

      <img class="halfScale 8-sub" style="top:301px;left:911px" src="/112/fr/static/_content/8-sub.png">

      <img class="halfScale pointer 8-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax()
          pg8Anim.fromTo(cOf("8-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("8-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("8-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop()
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE VÉ TÉR ANS  CHAMPIONNATS DU MONDE D'ESCRIME VÉTÉRANS LE CAIRE, ÉGYPTE 5 AU 11 OCTOBRE 2019",
      "mobileHtml":`
        <h2>Championnats du monde d'escrime vétérans</h2>
        <img id="fwdimg" src="/112/fr/static/_mobile/pg8.jpg">
        <p><b>LE CAIRE, Égypte<br>
          5 au 11 octobre 2019<br>
        </b></p>
      `,
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 9-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-red.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-red.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax()
          pg9Anim
            .fromTo(cOf("9-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg9Anim.stop()
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE VÉTÉRANS LE CAIRE, ÉGYPTE 2/3  Les Championnats du monde d'escrime vétérans du Caire se sont terminés après sept jours de compétition en individuel et par équipes passionnants qui ont réuni 699 tireurs de plus de 50 ans venus des cinq continents. La compétition, organisée dans les salles couvertes du Cairo Stadium Indoor Halls Complex, comprenait au total 24 épreuves au fleuret, à l'épée et au sabre. Les USA sont arrivés en tête du tableau des médailles avec six médailles d'or, suivis de la GrandeBretagne et de l'Italie, avec toutes deux quatre médailles d'or ; au total, 13 pays ont remporté au moins une médaille.",
      "mobileHtml":`

      
       
      

      <p>Les Championnats du monde d'escrime vétérans du Caire se sont terminés après sept jours de compétition en individuel et par équipes passionnants qui ont réuni 699 tireurs de plus de 50 ans venus des cinq continents. La compétition, organisée dans les salles couvertes du Cairo Stadium Indoor Halls Complex, comprenait au total 24 épreuves au fleuret, à l'épée et au sabre. Les USA sont arrivés en tête du tableau des médailles avec six médailles d'or, suivis de la Grande-Bretagne et de l'Italie, avec toutes deux quatre médailles d'or ; au total, 13 pays ont remporté au moins une médaille. </p>
      <p>En 2019, 46 fédérations des cinq régions continentales étaient représentées, et les épreuves ont été supervisées par des arbitres de la FIE appartenant à neuf fédérations distinctes. C'est la seconde fois que les Championnats du monde vétérans sont accueillis en Afrique. En 1997, une démonstration d'épée masculine vétéran avait été organisée lors des Championnats du monde d'escrime seniors au Cap, Afrique du Sud.</p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 10-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/10-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-red.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-red.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      <img class="halfScaleC pointer halfpulse animatedpulse" onclick="showOverlay('10-pop')" style="top:855px;left:59px" src="/112/fr/static/_content/trophy-red.png">

      <div id="10-pop" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/10-pop-bg.png">
        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC halfpulse animatedpulse" style="top:969px;left:833px" src="/112/fr/static/_content/10-trophy.png">
        </a>
        <div class="contentLink" style="top: 85px; left: 1343px; width: 166px; height: 49px;opacity:0" onclick="hideOverlay('10-pop');"></div>
        <img id="10-sabre" class="halfScale 10-events" style="top:302px;left:269px;opacity:1" src="/112/fr/static/_content/10-pop-1.png">
        <img id="10-foil" class="halfScale 10-events" style="top:394px;left:269px; opacity:0" src="/112/fr/static/_content/10-pop-2.png">
        <img id="10-epee" class="halfScale 10-events" style="top:421px;left:269px; opacity:0" src="/112/fr/static/_content/10-pop-3.png">

        <div class="contentLink" style="top:303px;left:269px;height:217px;width:113px;" onclick="toggleCategory('10-sabre', '10-events')" src="/112/fr/static/_content/10-pop-1.png"></div>
        <div class="contentLink" style="top:525px;left:269px;height:217px;width:113px;" onclick="toggleCategory('10-foil', '10-events')" src="/112/fr/static/_content/10-pop-2.png"></div>
        <div class="contentLink" style="top:747px;left:269px;height:217px;width:113px;" onclick="toggleCategory('10-epee', '10-events')" src="/112/fr/static/_content/10-pop-3.png"></div>

      </div>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax()
          pg10Anim
            .fromTo(cOf("10-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg10Anim.stop()
          hideOverlay('10-pop');
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE VÉTÉRANS LE CAIRE, ÉGYPTE 3/3  Cliquez ici pour voir les MÉDAILLÉS D'OR  En 2019, 46 fédérations des cinq régions continentales étaient représentées, et les épreuves ont été supervisées par des arbitres de la FIE appartenant à neuf fédérations distinctes. C'est la seconde fois que les Championnats du monde vétérans sont accueillis en Afrique. En 1997, une démonstration d'épée masculine vétéran avait été organisée lors des Championnats du monde d'escrime seniors au Cap, Afrique du Sud. ■  W W W.FIE .ORG",
      "mobileHtml": `
      
      <h2>Médaillés d'or</h2>
      <p><strong>Tableau des médaillés d'or des Championnats du monde d'escrime vétérans 2019:</strong></p>

      <br>

      <p><strong>OCT 5-7 2019</strong></p>

      <br>

      <p><strong>Sabre</strong></p>
      <p>Octobre 5</p>
      <p>Femmes	Individuel	Dorothea Tanzmeister (AUT)</p>
      <p>Femmes	Individuel	Lydia Mazarol (USA)</p>
      <p>Femmes	Individuel	Silvia Brown (GBR)</p>
      <p>Hommes	Individuel	Riccardo Carmina (ITA)</p>

      <br>

      <p><strong>Sabre</strong></p>
      <p>Octobre 6</p>
     <p>Hommes	Individuel	Mark Lundborg (USA)</p>
      <p>Hommes	Individuel	Joshua Runyan (USA)</p>
      <p>Femmes	Par équipes		Grande-Bretagne</p>

      <p><strong>Fleuret</strong></p>
      <p>Octobre 7</p>
      <p>Femmes	Individuel	Inessa Rodionova (RUS)</p>
      <p>Femmes	Individuel	Jenette Starks-Faulkner (USA)</p>
      <p>Femmes	Individuel	Marja-Liisa Tuulikki Someroja (FIN)</p>
      
      <p><strong>Sabre</strong></p>
      <p>Hommes	Par équipes		Italie</p>

      <br>

      <p><strong>OCT 8-9 2019</strong></p>

      <br>

      <p><strong>Fleuret</strong></p>
      <p>Octobre 8</p>
      <p>Hommes	Individuel	Christian Dousse (SUI)</p>
      <p>Hommes	Individuel	Paul Wedge (GBR)</p>
      <p>Hommes	Individuel	Brian Causton (GBR)</p>
      <p>Femmes	Par équipes		Russie</p>

      <p><strong>Épée</strong></p>
      <p>Octobre 9</p>
      <p>Femmes	Individuel	Dorothea Tanzmeister (AUT)</p>
      <p>Femmes	Individuel	Elizabeth Kocab (USA)</p>
      <p>Hommes	Individuel	Georg Schmidt-Thomes (GER)</p>
      
      <p><strong>Fleuret</strong></p>
      <p>Hommes	Par équipes		Italie</p>

      <br>

      <p><strong>OCT 10-11 2019</strong></p>

      <br>


      <p><strong>Épée</strong></p>
      <p>Octobre 10</p>
      <p>Hommes	Individuel	Michel Guy (FRA)</p>
      <p>Hommes	Individuel	Richard Purdie (AUS)</p>
      <p>Femmes	Par équipes		Marja-Liisa Tuulikki Someroja (FIN)</p>

      <br>

      <p><strong>Épée</strong></p>
      <p>Octobre 11</p>	
      <p>Femmes	Par équipes		Italie</p>
      <p>Hommes	Par équipes		USA</p>



      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 11-title" style="top:96px;left:86px" src="/112/fr/static/_content/11-title.png">

      <img class="halfScale 11-line" style="top:256px;left:929px" src="/112/fr/static/_content/11-line.png">

      <img class="halfScale 11-sub" style="top:250px;left:972px" src="/112/fr/static/_content/11-sub.png">

      <img class="halfScale pointer 11-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/8-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax()
          pg11Anim.fromTo(cOf("11-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("11-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("11-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("11-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg11Anim.stop()
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROUL ANT  CHAMPIONNATS DU MONDE D'ESCRIME EN FAUTEUIL CHEONGJU, CORÉE DU SUD ROULANT DE L’IWAS 17 AU 23 SEPTEMBRE 2019",
      "mobileHtml": `
      
      <h2>Championnats du monde d'escrime en fauteuil roulant de l’IWAS </h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg11.jpg">
      <p><strong>CHEONGJU, CORÉE DU SUD</strong></p>
      <p><strong>17 au 23 septembre 2019</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 12-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/8-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-red.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-red.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax()
          pg12Anim
            .fromTo(cOf("12-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg12Anim.stop()
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROULANT CHEONGJU, CORÉE DU SUD 2/3  Les escrimeurs chinois ont raflé 11 des 22 médailles d’or en jeu lors des Championnats du monde d'escrime en fauteuil roulant 2019 à Cheongju, en Corée du sud, en s’imposant dans les épreuves par équipe et en individuel, à l’épée, au fleuret et au sabre. Des épreuves étaient organisées dans les trois catégories paralympiques : A, B et C (selon le degré de handicap de l’athlète, la catégorie C désignant le handicap le plus sévère).* Plusieurs moments remarquables et passionnants ont pu être relevés lors de cette compétition des Championnats du monde. Le Chinois Shumei Tan s’est révélé être un concurrent de taille ; il a décroché des médailles d’or aussi bien au sabre qu’à l’épée dans la catégorie B, alors que cela ne fait qu’un peu plus d’un an qu’il a fait ses premiers pas dans le monde de l’escrime. La championne italienne paralympique de 22 ans, Beatrice Vio, a remporté sa troisième victoire consécutive au fleuret Dames dans la catégorie B, et les médaillés paralympiques Jianquan Tian, Xufeng Zou, Jing Rong, Yenke Feng et Jing Bian ont également rapporté des médailles d’or à la Chine.",
      "mobileHtml": `
      









      <p>Les escrimeurs chinois ont raflé 11 des 22 médailles d’or en jeu lors des Championnats du monde d'escrime en fauteuil roulant 2019 à Cheongju, en Corée du sud, en s’imposant dans les épreuves par équipe et en individuel, à l’épée, au fleuret et au sabre. Des épreuves étaient organisées dans les trois catégories paralympiques : A, B et C (selon le degré de handicap de l’athlète, la catégorie C désignant le handicap le plus sévère).*</p>
      <p>Plusieurs moments remarquables et passionnants ont pu être relevés lors de cette compétition des Championnats du monde. Le Chinois Shumei Tan s’est révélé être un concurrent de taille ; il a décroché des médailles d’or aussi bien au sabre qu’à l’épée dans la catégorie B, alors que cela ne fait qu’un peu plus d’un an qu’il a fait ses premiers pas dans le monde de l’escrime. La championne italienne paralympique de 22 ans, Beatrice Vio, a remporté sa troisième victoire consécutive au fleuret Dames dans la catégorie B, et les médaillés paralympiques Jianquan Tian, Xufeng Zou, Jing Rong, Yenke Feng et Jing Bian ont également rapporté des médailles d’or à la Chine. La Hongrie s’est imposée dans l’épreuve de fleuret Dames par équipe face à Hong Kong d’une seule touche (score final de 45 à 44) et, lors de l’épreuve individuelle de sabre Hommes, le russe Alexander Kurzin est reparti avec la médaille d’or qu’il convoitait tant après neuf années de tournois internationaux et six Championnats du monde.</p>
      <p>Les Championnats du monde d'escrime en fauteuil roulant de l’IWAS 2019 constituent un tournoi essentiel pour la préparation des Jeux Paralympiques de Tokyo en 2020. Tous les résultats sont disponibles ici. </p>
      <p>Vous avez également la possibilité de regarder la compétition à la demande sur la chaîne YouTube de l’IWAS.</p>
      <p>La prochaine épreuve sera la dernière Coupe du Monde d’escrime en fauteuil roulant de l’IWAS de l’année, qui se tiendra à Amsterdam, aux Pays-Bas, du 14 au 17 novembre.</p>
      <p>*Les épreuves de sabre Hommes et Dames dans la catégorie C n’ont pas eu lieu, et les résultats des épreuves épée et fleuret Dames dans la catégorie C ont été considérés comme non officiels, avec trois tireurs dans chaque épreuve.</p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 13-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/10-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-red.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-red.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>

      <a href="https://fie.org/competitions" target="_blank">
          <div class="contentLinkNone" style="top:581px;left:1103px;width:34px; height:30px;"></div>
      </a>

      <a href="https://www.youtube.com/channel/UCTnzFhDigJXhORjkBFAAihg" target="_blank">
          <div class="contentLinkNone" style="top:702px;left:840px;width:206px; height:30px;"></div>
      </a>

      <img class="halfScaleC pointer halfpulse animatedpulse" onclick="showOverlay('13-pop')" style="top:855px;left:59px" src="/112/fr/static/_content/trophy-red.png">

      <div id="13-pop" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/13-pop.png">
        <a href="https://fie.org/competitions" target="_blank">
          <img class="halfScaleC halfpulse animatedpulse" style="top:969px;left:837px" src="/112/fr/static/_content/10-trophy.png">
        </a>
        <div class="contentLink" style="top: 85px; left: 1343px; width: 167px; height: 49px;opacity:0" onclick="hideOverlay('13-pop');"></div>
      </div>
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax()
          pg13Anim
            .fromTo(cOf("13-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg13Anim.stop()
          hideOverlay('13-pop');
          removeConentLinks();
        }
      `,
      "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROULANT CHEONGJU, CORÉE DU SUD 3/3  La Hongrie s’est imposée dans l’épreuve de fleuret Dames par équipe face à Hong Kong d’une seule touche (score final de 45 à 44) et, lors de l’épreuve individuelle de sabre Hommes, le Russe Alexander Kurzin est reparti avec la médaille d’or qu’il convoitait tant après neuf années de tournois internationaux et six Championnats du monde. Les Championnats du monde d'escrime en fauteuil roulant de l’IWAS 2019 constituent un tournoi essentiel pour la préparation des Jeux Paralympiques de Tokyo en 2020. Tous les résultats sont disponibles ici. Vous avez également la possibilité de regarder la compétition à la demande sur la chaîne YouTube de l’IWAS. La prochaine épreuve sera la dernière Coupe du Monde d’escrime en fauteuil roulant de l’IWAS de l’année, qui se tiendra à Amsterdam, aux Pays-Bas, du 14 au 17 novembre.  Cliquez ici pour voir les MÉDAILLÉS D'OR  Les épreuves de sabre Hommes et Dames dans la catégorie C n’ont pas eu lieu, et les résultats des épreuves épée et fleuret Dames dans la catégorie C ont été considérés comme non officiels, avec trois tireurs dans chaque épreuve. ■ *  W W W.FIE .ORG",
      "mobileHtml": `
      
      <p><strong>INDIVIDUEL</strong></p>

      <br>

      <p><strong>Catégorie A</strong></p>
      <p>Épée masculine			Piers Gilliver (GBR)</p>
      <p>Épée féminine			Xufeng Zou (CHN)</p>
      <p>Fleuret masculin			Liqiang Chen (CHN)</p>
      <p>Fleuret féminin			Jing Rong (CHN)</p>
      <p>Sabre masculin			Jianquan Tian (CHN)</p>
      <p>Sabre féminin			Jing Bian (CHN)</p>

      <br>

      <p><strong>Catégorie B</strong></p>
      <p>Épée masculine			Dimitri Coutya (GBR)</p>
      <p>Épée féminine			Shumei Tan (CHN)</p>
      <p>Fleuret masculin			Yanke Feng (CHN)</p>
      <p>Fleuret féminin			Beatrice Maria Vio (ITA)</p>
      <p>Sabre masculin			Alexander Kurzin (RUS)</p>
      <p>Sabre féminin			Shumei Tan (CHN)</p>

      <br>

      <p><strong>Catégorie C</strong></p>
      <p>Épée masculine			Serhii Shavkun (UKR)</p>
      <p>Épée féminine (unofficial)	Consuelo Nora (ITA)</p>
      <p>Fleuret masculin			Nikolay Lukyanov (RUS)</p>
      <p>Fleuret féminin (unofficial)	Hann Pashkova (UKR)</p>
      <p>Sabre masculin			s/o</p>
      <p>Sabre féminin			s/o</p>

      <br>

      <p><strong>ÉQUIPE</strong></p>

      <br>

      <p>Épée masculine			Russie</p>
      <p>Épée féminine			Chine</p>
      <p>Fleuret masculin			Chine</p>
      <p>Fleuret féminin			Hongrie</p>
      <p>Sabre masculin			Ukraine</p>
      <p>Sabre féminin			Chine</p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
      <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('/112/fr/static/_content/11-vid.m4v')" style="bottom:460px;left:1146px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
        <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
      </svg>

      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.allstar.de" target="_blank">
        <img src="/112/fr/static/_mobile/pg14.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
          <a href="https://www.blaise-freres.fr" target="_blank">
            <div class="contentLinkNone" style="bottom:331px;right:1053px;width:256px; height:30px;"></div>
          </a>`,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/112/fr/static/_mobile/pg15.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 16-title" style="top:20px;left:71px" src="/112/fr/static/_content/16-no.png">

      <img class="halfScale 16-name-1" style="top:656px;left:-353px" src="/112/fr/static/_content/16-title-1.png">
      <img class="halfScale 16-name-2" style="top:773px;left:272px" src="/112/fr/static/_content/16-title-2.png">

      <img class="halfScale pointer 16-arrow" style="top:949px;left:1409px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/16-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax()
          pg16Anim
            .fromTo(cOf("16-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)
            .fromTo(cOf("16-name-1"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1},"-=0.2")
            .fromTo(cOf("16-name-2"), 0.4,{x:200,opacity:0}, {x:0,opacity:1},"-=0.1")
            .fromTo(cOf("16-arrow"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, "-=0.1")
        }

        function onPageLeave() {
          pg16Anim.stop()
        }
      `,
      "searchText": "À L A RENC ONTRE DES SP ORTIFS  			 SOFYA 					VELIKAYA",
      "mobileHtml": `
      
      <h2>À LA RENCONTRE DES SPORTIFS</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg16.jpg">
      <p><strong>Sofya Velikaya (RUS)</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      <img id="17-img-1" class="17-questions" style="top:18px;left:20px" src="/112/fr/static/_content/17-img-1.jpg">
      <img id="17-img-2" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-2.jpg">
      <img id="17-img-3" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-3.jpg">
      <img id="17-img-4" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-4.jpg">
      <img id="17-img-5" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-5.jpg">
      <img id="17-img-6" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-6.jpg">
      <img id="17-img-7" class="17-questions" style="top:18px;left:20px; display: none;" src="/112/fr/static/_content/17-img-7.jpg">

      <img id="17-no-1" class="halfScale 17-questions" style="top:417px;left:729px" src="/112/fr/static/_content/17-1.png">
      <img id="17-no-2" class="halfScale 17-questions" style="top:417px;left:730px; display: none;" src="/112/fr/static/_content/17-2.png">
      <img id="17-no-3" class="halfScale 17-questions" style="top:417px;left:729px; display: none;" src="/112/fr/static/_content/17-3.png">
      <img id="17-no-4" class="halfScale 17-questions" style="top:417px;left:729px; display: none;" src="/112/fr/static/_content/17-4.png">
      <img id="17-no-5" class="halfScale 17-questions" style="top:417px;left:729px; display: none;" src="/112/fr/static/_content/17-5.png">
      <img id="17-no-6" class="halfScale 17-questions" style="top:417px;left:729px; display: none;" src="/112/fr/static/_content/17-6.png">
      <img id="17-no-7" class="halfScale 17-questions" style="top:417px;left:729px; display: none;" src="/112/fr/static/_content/17-7.png">

      <div class="addContentLink" style="top: 443px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-1', '17-img-1')"></div>
      <div class="addContentLink" style="top: 538px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-2', '17-img-2')"></div>
      <div class="addContentLink" style="top: 629px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-3', '17-img-3')"></div>
      <div class="addContentLink" style="top: 722px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-4', '17-img-4')"></div>
      <div class="addContentLink" style="top: 813px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-5', '17-img-5')"></div>
      <div class="addContentLink" style="top: 907px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-6', '17-img-6')"></div>
      <div class="addContentLink" style="top: 1000px; left: 1382px; width: 132px; height: 97px;" onclick="swapQuestion('17-no-7', '17-img-7')"></div>
      <img id="17-next" class="halfScale pointer" style="top:949px;left:603px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/16-arrow.png">
      `,
      "script": `
      function onPageEnter() {
        pg17Anim = new TimelineMax()
        pg17Anim.fromTo(idOf("17-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function swapQuestion(ele, img) {
        var x = cOf("17-questions");
        var i;
        for (i = 0; i < x.length; i++) {
          x[i].style.display = 'none';
        }
        idOf(ele).style.display = ""
        idOf(img).style.display = ""
      }

      function onPageLeave() {
        pg17Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "La Russe Sofya Velikaya, actuellement N°2 mondiale au sabre, est l'une des tireuses les plus accomplies de l'histoire : septuple championne du monde, deux fois en individuel et cinq fois par équipes, elle a également remporté sept titres en Grand Prix. Nous lui avons posé quelques questions sur sa vie comme maman et ses objectifs en tant que tireuse parmi les meilleures du monde : Comment avez-vous découvert l'escrime ? Mes parents adorent le sport et jouaient au basketball et au volleyball. Nos parents nous ont transmis leur amour du sport. Grigory, le plus âgé de mes frères, faisait de la plongée, et lui et Trofim, le plus jeune, faisaient également de la gymnastique pendant que j'ai commencé la danse de salon et à jouer du piano. Mon frère Grigory m'a fait découvrir l'escrime en 1998. À cette époque, nous vivions à Almaty, mais Grigory avait déjà déménagé à Moscou et pratiquait l'escrime. Un jour, il est venu à la maison et il nous a parlé d'une nouvelle discipline, le sabre féminin, et il m'a dit que je pourrais essayer. Une nouvelle discipline signifie toujours davantage de chances d'exploiter pleinement votre potentiel, et offre de nombreuses opportunités. J'ai donc arrêté d'étudier à l'école de musique au cours de ma dernière année pour me consacrer à l'escrime, et je me suis complètement immergée dans ce sport.  1 2 3 4 5 6 7",
      "mobileHtml":`
      
      <p>La Russe Sofya Velikaya, actuellement N°2 mondiale au sabre, est l'une des tireuses les plus accomplies de l'histoire : septuple championne du monde, deux fois en individuel et cinq fois par équipes, elle a également remporté sept titres en Grand Prix. À 34 ans, cette maman de deux enfants a remporté de nombreuses compétitions majeures d'escrime depuis le début des années 2000, avec une première victoire en individuel aux Championnats du monde de Catane (Italie) en 2011. Nous lui avons posé quelques questions sur sa vie et ses objectifs en tant que tireuse parmi les meilleures du monde:</p>

      <p><strong>1) Comment avez-vous découvert l'escrime ? Quel âge aviez-vous ?</strong></p>
      <p>Mes parents adorent le sport et ont toujours été très actifs et jouaient au basketball et au volleyball. Nos parents nous ont transmis leur amour du sport. J'ai deux frères, Grigory, le plus âgé de mes frères, et Trofim, le plus jeune, et nous faisions sans cesse du sport. Grigory faisait de la plongée, et lui et Trofim faisaient également de la gymnastique pendant que j'ai commencé à apprendre la danse de salon et à jouer du piano. Grigory m'a fait découvrir l'escrime en 1998. À cette époque, nous vivions à Almaty, mais Grigory avait déjà déménagé à Moscou et pratiquait l'escrime. Un jour, il est venu à la maison et il nous a parlé d'une nouvelle discipline, le sabre féminin, et il m'a dit que je pourrais essayer. Une nouvelle discipline signifie toujours davantage de chances d'exploiter pleinement votre potentiel, et offre de nombreuses opportunités. J'ai donc arrêté d'étudier à l'école de musique au cours de ma dernière année pour me consacrer à l'escrime, et je me suis complètement immergée dans ce sport.</p>

      <p><strong>2) Comment se sont passées les premières années d'escrime?</strong></p>
      <p>Les deux premières années, je ne réalisais pas tout ce que je voulais, mais j'obtenais de bons résultats pour le Kazakhstan. En 2001, j'ai déménagé en Russie et j'ai intégré l'école de la Réserve olympique. Les conditions étaient géniales, mais c'était très exigeant : pour rester à l'école, vos résultats devaient être homogènes et vous deviez être un étudiant consciencieux. Le sport m'a donc rendu indépendante dès l'âge de 15 ans.</p>

      <p><strong>3) Par qui avez-vous été le plus influencée dans votre vie de tireuse ?</strong></p>
      <p>Nos parents choisissaient nos sports pour nous de manière à ce que nous puissions réaliser quelque chose par nous-mêmes, J'ai une famille ordinaire, mon père était ingénieur et ma mère travaillait dans la vente. Mon frère Grigory m'a beaucoup influencée lorsque je faisais mes études à l'école du sport.  Il m'a dit : « L'école t'apporte tout ce dont tu as besoin, elle te nourrit et met un toit au-dessus de ta tête. Tu peux accomplir quelque chose dans ce sport ». J'ai parcouru un long chemin. J'ai eu des hauts et des bas. J'ai rencontré de nombreuses personnes qui m'ont guidée et qui ont été (et sont toujours) très importantes pour moi. L'une d'entre elles est mon entraîneur, Dmitry Glotov, avec lequel j'ai partagé tant de choses, et bien sûr Christian Bauer, qui est associé à tous mes meilleurs résultats.</p>

      <p><strong>4) Comment parvenez-vous à combiner votre rôle de maman de deux enfants et votre carrière de tireuse de haut niveau ? Comment faites-vous pour que cela fonctionne ?</strong></p>
      <p>Mes enfants sont tout pour moi. Je suis parvenue à revenir deux fois dans le sport professionnel mais bien sûr, ce n'est pas facile. Mes parents m'aident beaucoup, ainsi que la fédération et les entraîneurs qui font preuve de beaucoup de patience et de compréhension. Je suis très reconnaissante à ma famille, à mes parents et à mes frères qui prennent soin de mes enfants lorsque je suis loin. Je passe tout mon temps libre avec mes enfants. Les entraîneurs m'aident à adapter ma préparation pour prendre en compte mes deux enfants. Bien sûr, je suis souvent fatiguée, mais mes victoires me donnent la force de continuer.</p>

      <p><strong>5) Parlez-nous de votre dernière saison - 2018-2019. Comment s'est-elle passée ?</strong></p>
      <p>Étant donné que j'ai repris le sport après avoir donné naissance à Zoya à la fin de la saison 2017 et que j'ai obtenu de bons résultats aux Championnats d'Europe et du monde, j'ai commencé cette saison avec des entraînements à plein temps. Mon entraîneur m'a préparé un calendrier et un programme d'entraînement tenant compte de tous les détails relatifs à ma santé et à mon âge. J'étais de plus en plus en forme à chaque compétition individuelle et par équipes. Je suis très heureuse que le processus de qualification olympique ait déjà commencé, et mes bons résultats m'ont permis de faire davantage attention à la performance par équipes. Les résultats par équipes sont extrêmement importants pour moi et j'aimerais que notre équipe obtienne des résultats plus homogènes. Je me sens responsable de tous les membres de notre équipe, surtout en étant celle qui termine les rencontres. Cette saison est très importante pour nous et notre équipe car nous devons réussir le processus de sélection pour les Jeux Olympiques. Actuellement, c'est la chose la plus importante à mes yeux, beaucoup plus que mes résultats individuels. Nous avons beaucoup de travail à abattre, mais d'un point de vue général nous n'avons pas fait une mauvaise saison.</p>

      <p><strong>6) Comment comparez-vous l'escrime individuelle et l'escrime par équipes ?</strong></p>
      <p>En escrime individuelle, vous êtes responsable de vous-même uniquement. Lorsque vous tirez par équipes, vous êtes responsable de tous les membres de cette équipe, y compris de toutes les personnes qui travaillent avec vous. Nos victoires par équipes sont très importantes et précieuses pour moi. C'est un sentiment incroyable que de ressentir toutes les émotions de vos coéquipières et de toutes les personnes autour de vous après une victoire. au début de ma carrière c'était dificile, mais des personnes ont cru en moi et m'ont fait terminer les rencontres. Vous ne pouvez pas vous détendre avant que la 45e touche ne soit marquée. Lorsqu'on tire par équipes, chaque erreur coûte cher et il est parfois très difficile de gérer cette pression.
      </p>

      <p><strong>7) Quel effet cela fait-il d'être double championne du monde ?</strong></p>
      <p>Si vous parlez de mes résultats individuels, ces victoires sont mes plus brillantes. Les matches les plus difficiles et les adversaires les plus coriaces. Ces succès sont très précieux pour moi, en particulier la victoire aux Championnats du monde de Moscou. Remporter ce type de compétition dans votre ville et faire plaisir à toutes les personnes qui sont venues vous soutenir, cela crée des moments inoubliables qui me donnent énormément d'émotions.</p>
      
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
          <a href="http://www.fencingsets.com" target="_blank">
            <div class="contentLinkNone" style="top:864px;left:283px;width:228px; height:30px;"></div>
          </a>

          <a href="mailto:755037302@qq.com">
            <div class="contentLinkNone" style="top:894px;left:283px;width:215px; height:30px;"></div>
          </a>

          <a href="mailto:1135864400@qq.com">
            <div class="contentLinkNone" style="top:894px;left:500px;width:173px; height:30px;"></div>
          </a>

          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.fencingsets.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg18.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 19-title" style="top:119px;left:86px" src="/112/fr/static/_content/19-title.png">

      <img class="halfScale 19-line" style="top:304px;left:87px" src="/112/fr/static/_content/19-line.png">

      <img class="halfScale 19-sub" style="top:303px;left:123px" src="/112/fr/static/_content/19-sub.png">

      <img class="halfScale pointer 19-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax()
          pg19Anim.fromTo(cOf("19-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("19-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("19-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
            .fromTo(cOf("19-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
        }

        function onPageLeave() {
          pg19Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  LA JOURNÉE MONDIALE DE L'ESCRIME AIDE LA PLANÈTE ! LAUSANNE, SUISSE 7 SEPTEMBRE 2019",
      "mobileHtml": `
      <h2>La Journée mondiale de l'escrime aide la planète !</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg19.jpg">
      <p><strong>LAUSANNE, Suisse, </strong></p>
      <p><strong>7 septembre 2019</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 20-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="https://www.youtube.com/watch?v=V6axJUC1Pzs" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:609px;left:49px" src="/112/fr/static/_content/yt-green.png">
      </a>
      <a href="https://www.instagram.com/explore/tags/fencingday/" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:848px;left:57px" src="/112/fr/static/_content/ig-green.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax()
          pg20Anim
            .fromTo(cOf("20-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg20Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/3  CLIQUEZ ICI pour consulter le page Youtube de la Journée mondiale de l'escrime  Des escrimeurs du monde entier se sont mobilisés lors de la troisième Journée mondiale de l'escrime, qui a eu lieu cette année le samedi 7 septembre, pour mettre leur détermination au service de leur communauté, avec notamment des actions humanitaires et de protection de l'environnement.  CLIQUEZ ICI pour voir la Journée mondiale de l'escrime sur Instagram  La Journée mondiale de l'escrime a été l'occasion pour les tireurs de se rassembler pour mener des actions en lien avec le thème de cette année, « L'escrime pour notre planète ». Aux quatre coins du monde, que ce soit par des projets pour aider l'environnement, de bonnes œuvres pour les personnes en difficulté dans la communauté,  ou par la mise en place de politiques de durabilité dans des clubs ou lors de tournois, la Journée mondiale de l'escrime et des tireurs des cinq continents se sont efforcés de rendre ce monde meilleur.",
      "mobileHtml": `
      

      
      
    
      <p>Des escrimeurs du monde entier se sont mobilisés lors de la troisième Journée mondiale de l'escrime, qui a eu lieu cette année le samedi 7 septembre, pour mettre leur détermination au service de leur communauté, avec notamment des actions humanitaires et de protection de l'environnement.</p>

      <p>La Journée mondiale de l'escrime a été l'occasion pour les tireurs de se rassembler pour mener des actions en lien avec le thème de cette année, « L'escrime pour notre planète ». Aux quatre coins du monde, que ce soit par des projets pour aider l'environnement, de bonnes œuvres pour les personnes en difficulté dans la communauté, ou par la mise en place de politiques de durabilité dans des clubs ou lors de tournois, la Journée mondiale de l'escrime et des tireurs des cinq continents se sont efforcés de rendre ce monde meilleur.</p>
      
      <p>Avez-vous participé à la Journée mondiale de l'escrime ? Si oui, il n'est pas trop tard pour nous envoyer vos récits et vos photos ! Publiez des stories de vos bonnes actions (avec des photos s'il vous paît !) sur les réseaux sociaux de la FIE (Facebook, Twitter ou Instagram), utilisez le hashtag #FencingforourPlanet, et vous serez automatiquement inscrit pour le tirage au sort qui vous permettra peut-être de remporter une médaille commémorative du 105e anniversaire de la FIE. Plusieurs médailles sont en jeu et la date limite approche, alors publiez votre story dès maintenant !</p>

      
      

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 21-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax()
          pg21Anim
            .fromTo(cOf("21-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg21Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 3/3  Avez-vous participé à la Journée mondiale de l'escrime ? Si oui, il n'est pas trop tard pour nous envoyer vos récits et vos photos ! Publiez des stories de vos bonnes actions (avec des photos s'il vous plaît !) sur les réseaux sociaux de la FIE (Facebook, Twitter ou Instagram), utilisez le hashtag #FencingforourPlanet, et vous serez automatiquement inscrit pour le tirage au sort qui vous permettra peut-être de remporter une médaille commémorative du 105e anniversaire de la FIE. Plusieurs médailles sont en jeu et la date limite approche, alors publiez votre story dès maintenant !  locaux, des fédérations nationales d'escrime et des entraîneurs d'escrime s'unissent pour faire découvrir l'escrime dans leurs régions. Les 153 fédérations membres de la FIE, réparties aux quatre coins du monde, organisent une multitude d'activités, et des fédérations, des clubs, des athlètes, des individus, des fabricants et des fans qui aiment l'escrime se joignent tous aux festivités. ■  À propos de la Journée mondiale de l'escrime Lors de la Journée mondiale de l'escrime, organisée chaque année le samedi du deuxième week-end de septembre, des athlètes ayant participé aux Olympiades et aux Championnats du monde, des clubs d'escrime  W W W.FIE .ORG",
      "mobileHtml":`
      
      

      
      <p><strong>À propos de la Journée mondiale de l'escrime</strong></p>
      <p>Lors de la Journée mondiale de l'escrime, organisée chaque année le samedi du deuxième week-end de septembre, des athlètes ayant participé aux Olympiades et aux Championnats du monde, des clubs d'escrime locaux, des fédérations nationales d'escrime et des entraîneurs d'escrime s'unissent pour faire découvrir l'escrime dans leurs régions. Les 153 fédérations membres de la FIE, réparties aux quatre coins du monde, organisent une multitude d'activités, et des fédérations, des clubs, des athlètes, des individus, des fabricants et des fans qui aiment l'escrime se joignent tous aux festivités. </p>

      <p>Cliquez sur <a href="https://www.instagram.com/explore/tags/fencingforourplanet/" target="_blank">#FencingForOurPlanet</a> pour lire d'autres stories sur Instagram</p>

      <p>Découvrez le <a href="https://twitter.com/hashtag/FencingDay?src=hashtag_click" target="_blank">#FencingDay</a> sur Twitter </p>
      
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
          <a href="http://www.blue-gauntlet.com" target="_blank">
            <div class="contentLinkNone" style="top:939px;left:250px;width:1080px; height:75px;"></div>
          </a>
          
          <a href="mailto:service@blue-gauntletservice.com">
            <div class="contentLinkNone" style="top:1028px;left:384px;width:823px; height:49px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.blue-gauntlet.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg22.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 23-title" style="top:148px;left:83px" src="/112/fr/static/_content/23-title.png">

      <img class="halfScale 23-line" style="top:506px;left:92px" src="/112/fr/static/_content/23-line.png">

      <img class="halfScale 23-sub" style="top:505px;left:127px" src="/112/fr/static/_content/23-sub.png">

      <img class="halfScale pointer 23-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">

      <a href="https://twitter.com/hashtag/FencingDay?src=hashtag_click" target="_blank">
        <div class="contentLinkNone" style="top:915px;left:502px;width:223px; height:43px;"></div>
      </a>
      `,
      "script": `
        
      function onPageEnter() {
        pg23Anim = new TimelineMax()
        pg23Anim.fromTo(cOf("23-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("23-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("23-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("23-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, "-=0.2")
      }

      function onPageLeave() {
        pg23Anim.stop();
        removeContentLinks();
      }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  JOURNÉE MONDIALE DE L'ESCRIME SIÈGE SOCIAL DE LA FIE LAUSANNE, SUISSE 7 SEPTEMBRE 2019",
      "mobileHtml": `
      
      <h2>Journée mondiale de l'escrime - Siège social de la FIE</h2> 
      <img id="fwdimg" src="/112/fr/static/_mobile/pg23.jpg">
      <p><strong>
        LAUSANNE, Suisse</strong></p>
      <p><strong>7 septembre 2019</strong></p>
      
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 24-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>


      <a href="https://www.instagram.com/explore/tags/fencingforourplanet/" target="_blank">
        <div class="contentLinkNone" style="top:1036px;left:840px;width:257px; height:41px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax()
          pg24Anim
            .fromTo(cOf("24-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg24Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  La troisième Journée mondiale de l'escrime, organisée chaque année, a eu lieu le samedi 7 septembre sur le thème « L'escrime pour notre planète ». Comme annoncé à l'avance, « la FIE espère ainsi que les tireurs peuvent montrer au monde que l'escrime n'est pas juste un sport, mais un état d'esprit positif qui peut proﬁter aussi bien aux individus qu'aux communautés dans lesquelles ils vivent. Le thème « L'escrime pour notre planète » de la Journée mondiale de l'escrime est un appel à l'action lancé à la famille mondiale de l'escrime pour montrer que l'escrime et les escrimeurs se soucient des personnes et de la planète ».  Le Siège social de la FIE a organisé l'initiative avec beaucoup d'enthousiasme, en coopération avec deux partenaires :  Dans l'esprit de ce message, et en phase avec un siège et une organisation qui accordent une attention toujours plus importante à la durabilité, le personnel du Siège social de la FIE à Lausanne a décidé collectivement d'organiser un nettoyage de la plage située à proximité de ses locaux et le long des rives du Lac de Genève, sur une section allant de la plage de Vidy à Saint-Sulpice. S'attaquer au problème des déchets jetés dans la nature est une mesure profitant à la fois à la santé humaine et à l'environnement.  Les types de déchets collectés sont saisis dans la base de données de l'ASL et analysés ensuite dans le cadre d'une enquête statistique visant à en apprendre davantage et à mieux comprendre comment protéger le lac Léman. L'impact de la contribution au ramassage des déchets du personnel de la FIE sera ainsi amplifié et accru, ce qui permettra d'aider encore davantage les personnes et l'environnement.  Cheval et Environnement, qui fournit un moyende transport écologique pour l'évacuation desordures l'ASL (Association for the Conservation of theLeman Lake), qui fournit les outils permettant de ramasser les déchets abandonnés dans les rues ou sur les plages  #FencingForOurPlanet. ■ W W W.FIE .ORG",

      "mobileHtml":`
    
      <p>La troisième Journée mondiale de l'escrime, organisée chaque année, a eu lieu le samedi 7 septembre sur le thème « L'escrime pour notre planète ». Comme annoncé à l'avance, « la FIE espère ainsi que les tireurs peuvent montrer au monde que l'escrime n'est pas juste un sport, mais un état d'esprit positif qui peut profiter aussi bien aux individus qu'aux communautés dans lesquelles ils vivent. Le thème « L'escrime pour notre planète » de la Journée mondiale de l'escrime est un appel à l'action lancé à la famille mondiale de l'escrime pour montrer que l'escrime et les escrimeurs se soucient des personnes et de la planète ».</p>
      
      <p>Dans l'esprit de ce message, et en phase avec un siège et une organisation qui accordent une attention toujours plus importante à la durabilité, le personnel du Siège social de la FIE à Lausanne a décidé collectivement d'organiser un nettoyage de la plage située à proximité de ses locaux et le long des rives du Lac de Genève, sur une section allant de la plage de Vidy à Saint-Sulpice. S'attaquer au problème des déchets jetés dans la nature est une mesure profitant à la fois à la santé humaine et à l'environnement.</p>
      <p>Le Siège social de la FIE a organisé l'initiative avec beaucoup d'enthousiasme, en coopération avec deux partenaires :</p>

      <p>- Cheval et Environnement, qui fournit un moyen de transport écologique pour l'évacuation des ordures</p>
      <p>- l'ASL (Association for the Conservation of the Leman Lake), qui fournit les outils permettant de ramasser les déchets abandonnés dans les rues ou sur les plages</p>

      <p>Les types de déchets collectés sont saisis dans la base de données de l'ASL et analysés ensuite dans le cadre d'une enquête statistique visant à en apprendre davantage et à mieux comprendre comment protéger le lac Léman. L'impact de la contribution au ramassage des déchets du personnel de la FIE sera ainsi amplifié et accru, ce qui permettra d'aider encore davantage les personnes et l'environnement.</p>

      <p><a href="https://twitter.com/hashtag/FencingForOurPlanet?src=hashtag_click" target="_blank">#FencingForOurPlanet</a></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
          <a href="http://favero.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:1000px;width:165px; height:55px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://favero.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg25.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
          <a href="http://www.jiangfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:1000px;left:816px;width:223px; height:25px;"></div>
          </a>

          <a href="mailto:jason@jiangfencing.com">
            <div class="contentLinkNone" style="top:1025px;left:828px;width:239px; height:25px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.jiangfencing.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg26.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 27-title" style="top:88px;left:694px" src="/112/fr/static/_content/27-title.png">

      <img class="halfScale 27-line" style="top:254px;left:702px" src="/112/fr/static/_content/27-line.png">

      <img class="halfScale 27-sub" style="top:248px;left:739px" src="/112/fr/static/_content/27-sub.png">

      <img class="halfScale pointer 27-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">
      `,
      "script": `
        
      function onPageEnter() {
        pg27Anim = new TimelineMax()
        pg27Anim.fromTo(cOf("27-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("27-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("27-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("27-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg27Anim.stop()
      }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES © Jose Sotomayor / Lima 2019  JEUX PANAMÉRICAINS LIMA, PÉROU 5 AU 10 AOÛT 2019",
      "mobileHtml":`
      
      <h2>Jeux Panaméricains</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg27.jpg">
      <p><strong>LIMA, Pérou</strong></p>
      <p><strong>5 au 10 août 2019</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 28-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="https://static.fie.org/uploads/22/114371-Newsletter%20CPE%20Vol-3Num-1%20Aug%202019%20Eng.pdf" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:771px;left:36px" src="/112/fr/static/_content/paper-green.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax()
          pg28Anim
            .fromTo(cOf("28-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg28Anim.stop()
        }
      `,
      "searchText": "© Claudio Cruz/Lima 2019  ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  © Lima 2019  © Rojas Lima 2019  © Fidel Carrillo/Lima 2019  © César Fajardo/ Lima 2019  CLIQUEZ ICI pour consulter le bulletin d'information de la CPE.  La compétition d'escrime des dix-septième Jeux Panaméricains à Lima, Pérou, a été disputée par 156 athlètes de 16 fédérations nationales, avec au programme des épreuves hommes et dames en individuel et par équipes à l'épée, au fleuret et au sabre. La compétition s'est déroulée du 5 au 10 août au Centre de convention de la ville de Lima. ■ W W W.FIE .ORG",
      "mobileHtml":`
      
      
      

      <p>La compétition d'escrime des dix-septième Jeux Panaméricains à Lima, Pérou, a été disputée par 156 athlètes de 16 fédérations nationales, avec au programme des épreuves hommes et dames en individuel et par équipes à l'épée, au fleuret et au sabre. La compétition s'est déroulée du 5 au 10 août au Centre de convention de la ville de Lima.</p>

      <p>Pour consulter le bulletin d'information de la CPE, cliquez <a href="https://static.fie.org/uploads/22/114371-Newsletter%20CPE%20Vol-3Num-1%20Aug%202019%20Eng.pdf" target="_blank">ici.</a></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      <div class="contentLink" style="bottom:193px;right:633px;width:180px; height:30px;">
      <a href="http://www.uhlmann-fencing.com" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:198px;right:844px;width:30px; height:30px;">
        <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:198px;right:813px;width:30px; height:30px;">
        <a href="http://www.instagram.com/Uhlmann.Fencing" target="_blank"></a>
    </div>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.uhlmann-fencing.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg29.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 30-title" style="top:221px;left:83px" src="/112/fr/static/_content/30-title.png">

      <img class="halfScale 30-line" style="top:572px;left:89px" src="/112/fr/static/_content/30-line.png">

      <img class="halfScale 30-sub" style="top:572px;left:125px" src="/112/fr/static/_content/30-sub.png">

      <img class="halfScale pointer 30-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">
      `,
      "script": `
        
      function onPageEnter() {
        pg30Anim = new TimelineMax()
        pg30Anim.fromTo(cOf("30-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("30-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("30-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("30-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg30Anim.stop()
      }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  LA VILLE DE GUATEMALA CÉLÈBRE LA JOURNÉE MONDIALE DE L'ESCRIME GUATEMALA, GUATEMALA 7 SEPTEMBRE 2019",
      "mobileHtml": `
      
      <h2>La ville de Guatemala célèbre la Journée mondiale de l'escrime</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg30.jpg">
      <p><strong>GUATEMALA, GUATEMLA</strong></p>
      <p><strong>7 septembre 2019</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 31-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="https://www.youtube.com/watch?v=f0UbfMNTScE&feature=youtu.be" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:638px;left:49px" src="/112/fr/static/_content/yt-green.png">
      </a>
      <a href="https://www.facebook.com/pg/FederacionNacionalDeEsgrimaGuatemala/photos/?tab=album&album_id=2302027523229081&__xts__%5B0%5D=68.ARA7BG0xhcCICYBxCJEXu6hY87Df3urP17Apsz10GWy4neOzovRJpCGWYSrh6R-7Jf-NqL_4SdgIB1aNAMsHnxWUtAX9d9KDFX0mjCKWRNxbfDag6HYQSXNCSHjvgLKUQnTPQgnTD7ybrITtD2dMakiUfb9e7k5L8YhL8YQcnhfrCgtUfUtgbsHluwuNFHqe31DS86JB05Q2J2OQwjmYkSm83HaEeN4QiEUyglSKYtTzcg7RZEO4DW37TmFU8pV9cV1g5M8jbC4hMHv1NA2Pil9hrx3zYM9nLPJXzOBtM-2yObUC1IiU_y5Poa73jf3KvSbPV78BiQyuYD2sxex0biYmA2h0XiCj4VKMvTdq9gXrNuOcdTh7aMNbNy4ttrz6PpaclC82IJ9B9YIS4jmThhYg4_TJJxqTZy9Cq9y3RYHmFX98Y9qUbSOEiXyA4ZqRa5zUoPL_nUc0cywgo-MAqpdXhb9hrcGddotGh8981wB-zsW1EIraD_LW32w3bhQGx-3hvVlh3ZuQOHVZlf8gP4A4f9uyF3BTQZ7TlqSI__HAwj2Bb2shVwSB4XkKDBtcbk3q_SDvg9nSsGcZIZDOLjlkSyJyUEaUoT2TeMyilIUs8zzvc-ebVs3o2n_zzVaFKMQ1qfeJ7aR_58B0WkWrHE3zUIVntLfJPEjYoYkr52WE6IFxbSlZ8-JYDA3z73puH8JTdEWHQcnbC9mL5uvxLw&__tn__=-UC-R" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:857px;left:48px" src="/112/fr/static/_content/pic-green.png">
      </a>

      <a href="https://twitter.com/search?q=%23WorldFencingDay&src=typed_query" target="_blank">
          <div class="contentLinkNone" style="top:1012px;left:846px;width:206px; height:28px;"></div>
      </a>

      <a href="https://twitter.com/hashtag/FencingDay?src=hashtag_click" target="_blank">
          <div class="contentLinkNone" style="top:1012px;left:1053px;width:146px; height:28px;"></div>
      </a>

      <a href="https://twitter.com/hashtag/fencingforourplanet" target="_blank">
          <div class="contentLinkNone" style="top:1042px;left:845px;width:246px; height:28px;"></div>
      </a>

      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax()
          pg31Anim
            .fromTo(cOf("31-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg31Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  CLIQUEZ ICI pour regarder les videos de l'événement sur Youtube  CLIQUEZ ICI pour voir les images  Afin de célébrer la Journée mondiale de l'escrime, qui s’est déroulée le 7 septembre, la Fédération nationale d'escrime du Guatemala a organisé la plantation de 100 arbres en lien avec le thème « L'escrime pour notre planète » de l'événement annuel. Des bénévoles ont rejoint des membres de la Fédération pour aider à planter des pousses d'érythrine et de frêne à proximité de l’Asunción Ecological Park de la ville de Guatemala. L'effort a été mené dans le cadre d'une initiative plus vaste visant à encourager les pratiques de durabilité dans le pays, et a été illustré par des  photos et des vidéos avec le soutien de plusieurs organisations, notamment la Confédération des sports autonomes de Guatemala et la Municipalité de Guatemala.  #WorldFencingDay #FencingDay #FencingForOurPlanet. ■ W W W.FIE .ORG",
      "mobileHtml":`
      
      



      <p>Afin de célébrer la Journée mondiale de l'escrime, qui s’est déroulée le 7 septembre, la Fédération nationale d'escrime du Guatemala a organisé la plantation de 100 arbres en lien avec le thème « L'escrime pour notre planète » de l'événement annuel. Des bénévoles ont rejoint des membres de la Fédération pour aider à planter des pousses d'érythrine et de frêne à proximité de l’Asunción Ecological Park de la ville de Guatemala. L'effort a été mené dans le cadre d'une initiative plus vaste visant à encourager les pratiques de durabilité dans le pays, et a été illustré par des photos et des vidéos avec le soutien de plusieurs organisations, notamment la Confédération des sports autonomes de Guatemala et la Municipalité de Guatemala.</p>

      <p><a href="https://twitter.com/search?q=%23WorldFencingDay&src=typed_query" target="_blank">#WorldFencingDay</a> <a href="https://twitter.com/hashtag/FencingDay?src=hashtag_click" target="_blank">#FencingDay</a> <a href="https://twitter.com/hashtag/fencingforourplanet" target="_blank">#FencingForOurPlanet</a></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
          <a href="mailto:sales@pbtfencing.com">
            <div class="contentLinkNone" style="top:1057px;left:66px;width:263px; height:28px;"></div>
          </a>

          <a href="http://www.pbtfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:1057px;left:643px;width:249px; height:28px;"></div>
          </a>

          <a href="https://www.instagram.com/pbt_fencing/" target="_blank">
            <div class="contentLinkNone" style="top:1057px;left:1129px;width:343px; height:28px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="http://www.pbtfencing.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg32.jpg">
      </a>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 33-title" style="top:793px;left:70px" src="/112/fr/static/_content/33-title.png">

      <img class="halfScale 33-line" style="top:1002px;left:341px" src="/112/fr/static/_content/33-line.png">

      <img class="halfScale 33-sub" style="top:1002px;left:377px" src="/112/fr/static/_content/33-sub.png">

      <img class="halfScale pointer 33-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">
      `,
      "script": `
        
      function onPageEnter() {
        pg33Anim = new TimelineMax()
        pg33Anim.fromTo(cOf("33-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("33-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("33-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("33-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg33Anim.stop()
      }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  CAMP D’ENTRAÎNEMENT DE LA FIE À BUDAPEST BUDAPEST, HONGRIE 8 AU 12 JUILLET 2019",
      "mobileHtml":`
      
      <h2>CAMP D’ENTRAINEMENT DE LA FIE A BUDAPEST</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg33.jpg">
      <p><strong>Budapest, Hongrie</strong></p>
      <p><strong>8 au 12 juillet 2019</strong></p>

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 34-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      <img class="halfScaleC pointer halfpulse animatedpulse" onclick="showOverlay('34-pop')" style="top:634px;left:53px" src="/112/fr/static/_content/notepad-gr.png">
      <a href="https://youtu.be/_RZ-Oi4qUuU" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:870px;left:50px" src="/112/fr/static/_content/yt-green.png">
      </a>

      <div id="34-pop" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/34-pop.jpg">
        <div class="contentLink" style="top: 82px; left: 81px; width: 181px; height: 49px;opacity:0" onclick="hideOverlay('34-pop');"></div>
      </div>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax()
          pg34Anim
            .fromTo(cOf("34-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg34Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  La FIE a organisé un camp d’entraînement la semaine avant les Championnats du monde Senior à Budapest, en Hongrie. Sélectionnés par les Confédérations, 20 athlètes de toutes les armes ont pris part à une semaine intensive d’entraînement. Il y avait 10 hommes et 10 femmes âgés de 18 à 35 ans, de la Dominique, du Nigeria, de Irlande, de la Malaisie, de la Nouvelle-Zélande, parmi d’autres pays. Deux sessions d’entraînement par jour étaient organisées pour que les athlètes soient prêts à participer à la compétition la plus importante de l’année, les Championnats du monde Senior (15-23 juillet 2019).  CLIQUEZ ICI pour consulter les faits et chiffres du camp de la FIE  CLIQUEZ ICI pour regarder les temps forts  Les entraînements ont eu lieu à la salle de sport nationale Aladar Gerevich où l’équipe nationale hongroise s’entraîne durant la saison, et où les délégations des championnats du monde se préparaient pour la compétition. Les trois entraîneurs désignés étaient Alina Zholudeva, Cyril Tahon et Petru Kuki. « L’atmosphère et la collaboration étaient très bonnes », a avancé ce dernier. D’après Cyril  Tahon, l’organisation du camp d’entraînement était optimale, les athlètes étaient motivés et avaient soif d’apprendre. Quant à Alina Zholudeva, elle a loué le travail ardu des tireurs et le déroulement du camp. En plus des entraînements, les athlètes ont pris part à l’atelier du CIO « 365 Career + » qui vise à préparer les athlètes pour leur carrière professionnelle après le sport. Des vidéos, jeux et échanges entre eux ont rendu l’atelier interactif et vivant. À la compétition, Teodora Kakhiani de Géorgie a terminé 30ème au sabre féminin. Le prochain camp d’entraînement de la FIE aura lieu à Salt Lake City (USA) avant les Championnats du monde Junior & Cadet, en mars 2020. ■ W W W.FIE .ORG",
      "mobileHtml":`
      
      
      
      
      
      
      
      
      

      <p>La FIE a organisé un camp d’entraînement la semaine avant les Championnats du monde Senior à Budapest, en Hongrie.</p>
      <p>Sélectionnés par les Confédérations, 20 athlètes de toutes les armes ont pris part à une semaine intensive d’entraînement. Il y avait 10 hommes et 10 femmes âgés de 18 à 35 ans, de la Dominique, Nigeria, Irlande, Malaisie, Nouvelle-Zélande, parmi d’autres pays.</p>
      <p>Deux sessions d’entraînement par jour étaient organisées pour que les athlètes soient prêts à participer à la compétition la plus importante de l’année, les Championnats du monde Senior (15-23 juillet 2019).</p>
      <p>Les entraînements ont eu lieu à la salle de sport nationale Aladar Gerevich où l’équipe nationale hongroise s’entraîne durant la saison, et où les délégations des championnats du monde se préparaient pour la compétition..</p>
      <p>Les trois entraîneurs désignés étaient Alina Zholudeva, Cyril Tahon et Petru Kuki. « L’atmosphère et la collaboration étaient très bonnes », a avancé ce dernier. D’après Cyril Tahon, l’organisation du camp d’entraînement était optimale, les athlètes étaient motivés et avaient soif d’apprendre. Quant à Alina Zholudeva, elle a loué le travail ardu des tireurs et le déroulement du camp.</p>
      <p>En plus des entraînements, les athlètes ont pris part à l’atelier du CIO « 365 Career + » qui vise à préparer les athlètes pour leur carrière professionnelle après le sport. Des vidéos, jeux et échanges entre eux ont rendu l’atelier interactif et vivant.</p>
      <p>A la compétition, Teodora Kakhiani de Géorgie a terminé 30ème au sabre féminin.</p>
      <p>Le prochain camp d’entraînement de la FIE aura lieu à Salt Lake City (USA) avant les Championnats du monde Junior & Cadet, en mars 2020.</p>

      <p>Quelques chiffres :</p>
      <p>•	10 hommes et 10 femmes</p>
      <p>•	9 épéistes</p>
      <p>•	5 fleurettistes</p>
      <p>•	6 sabreurs</p>
      <p>•	6 athlètes d’Asie-Océanie</p>
      <p>•	8 athlètes d’Europe</p>
      <p>•	1 athlète d’Afrique (un s’est retiré)</p>
      <p>•	5 athlètes des Amériques</p>
      
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/112/fr/static/_mobile/pg35.jpg">
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 36-title" style="top:764px;left:167px" src="/112/fr/static/_content/36-title.png">

      <img class="halfScale 36-line" style="top:1037px;left:344px" src="/112/fr/static/_content/36-line.png">

      <img class="halfScale 36-sub" style="top:1032px;left:379px" src="/112/fr/static/_content/36-sub.png">

      <img class="halfScale pointer 36-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/19-arrow.png">
      `,
      "script": `
        
      function onPageEnter() {
        pg36Anim = new TimelineMax()
        pg36Anim.fromTo(cOf("36-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("36-line"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("36-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("36-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg36Anim.stop()
      }
      `,
      "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  COURS POUR ENTRAÎNEURS DE LA SOLIDARITÉ OLYMPIQUE AOÛT-SEPTEMBRE 2019",
      "mobileHtml": `
      
      <h2>Solidarité Olympique - Cours pour entraîneurs</h2>
      <img id="fwdimg" src="/112/fr/static/_mobile/pg36.jpg">
      <p><strong>août-septembre 2019</strong></p>
      
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 37-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/21-arrow.png">

      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/112/fr/static/_content/tw-green.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/112/fr/static/_content/fb-green.png">
      </a>
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax()
          pg37Anim
            .fromTo(cOf("37-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg37Anim.stop()
        }
      `,
      "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  L’enseignement de l’escrime a été mis en lumière en Asie, Afrique et Pan Amérique. En effet, cinq cours techniques pour entraîneurs de la Solidarité Olympique étaient organisés en Angola, Mongolie, Haïti, Colombie et à Bahreïn, entre août et septembre 2019. Affiliée à la FIE depuis le Congrès 2017, la fédération d’Angola a accueilli le premier cours pour entraîneurs de son histoire. Dirigé par Régis Trois de Avila, le cours a rassemblé près de 40 participants hommes et femmes sur une durée de 8 jours à Luanda. Depuis, les participants ont préparé leurs tireurs pour le championnat national de la fin de 2019. Ulaan Bator, en Mongolie, a rassemblé une vingtaine de participants, tous entraîneurs confirmés, durant une semaine de cours à l’épée. Aleksandr Rovniagin a encadré ce séminaire technique en mettant l’accent sur la pratique : jeu de jambes, attaques simples à complexes, actions pour choisir la distance exigée, entre autres. Matteo Scamarda s’est quant à lui rendu à Bahreïn pour un cours de 11 jours. Près de  30 participants hommes et femmes ont suivi la formation à l’épée et au fleuret. Ils ont été entraînés aux techniques de base, aspects psychologique et comportemental, stratégies de combat et à l’arbitrage. En septembre, la fédération haïtienne a reçu la visite de Mario Bourdageau pour un séminaire de 10 jours à Port-au-Prince, au fleuret. Le cours s’est déroulé durant 70 heures, comptant 25 participants, entraîneurs ou athlètes haïtiens. Mario Bourdageau a abordé les fondamentaux : travail de jambes, attaques et défenses simples, comment diriger un groupe en sécurité, et arbitrage, notamment. En Colombie, un cours au fleuret était organisé sur 13 jours à Bogotá. Une vingtaine de participants étaient formés par Luca Papale. Les leçons étaient basées sur les fondamentaux : attaques, ripostes, contre-attaques et jeu de jambes. ■ W W W.FIE .ORG",
      "mobileHtml": `
      
      <p>L’enseignement de l’escrime a été mis en lumière en Asie, Afrique et Pan Amérique. En effet, cinq cours techniques pour entraîneurs de la Solidarité Olympique étaient organisés en Angola, Mongolie, Haïti, Colombie et à Bahreïn, entre août et septembre 2019.</p>

      <p>Affiliée à la FIE depuis le Congrès 2017, la fédération d’Angola a accueilli le premier cours pour entraîneurs de son histoire. Dirigé par Régis Trois de Avila, le cours a rassemblé près de 40 participants hommes et femmes sur une durée de 8 jours à Luanda. Depuis, les participants ont préparé leurs tireurs pour le championnat national de la fin de 2019.</p>

      <p>Ulaan Bator, en Mongolie, a rassemblé une vingtaine de participants, tous entraîneurs confirmés, durant une semaine de cours à l’épée. Aleksandr Rovniagin a encadré ce séminaire technique en mettant l’accent sur la pratique : jeu de jambes, attaques simples à complexes, actions pour choisir la distance exigée, entre autres.</p>

      <p>Matteo Scamarda s’est quant à lui rendu à Bahreïn pour un cours de 11 jours. Près de 30 participants hommes et femmes ont suivi la formation à l’épée et au fleuret. Ils ont été entraînés aux techniques de base, aspects psychologique et comportemental, stratégies de combat et à l’arbitrage.</p>

      <p>En septembre, la fédération haïtienne a reçu la visite de Mario Bourdageau pour un séminaire de 10 jours à Port-au-Prince, au fleuret. Le cours s’est déroulé durant 70 heures, comptant 25 participants, entraîneurs ou athlètes haïtiens. Mario Bourdageau a abordé les fondamentaux : travail de jambes, attaques et défenses simples, comment diriger un groupe en sécurité, et arbitrage, notamment.</p>

      <p>En Colombie, un cours au fleuret était organisé sur 13 jours à Bogotá. Une vingtaine de participants étaient formés par Luca Papale. Les leçons étaient basées sur les fondamentaux : attaques, ripostes, contre-attaques et jeu de jambes.</p>
      

      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
        <img src="/112/fr/static/_mobile/pg38.jpg">
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `

          <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:18px;width:614px; height:43px;"></div>
          </a>

          <a href="mailto:info@fencewithfun.com">
            <div class="contentLinkNone" style="top:940px;left:75px;width:219px; height:28px;"></div>
          </a>

          <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:942px;left:353px;width:214px; height:28px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml": `
      
      <a href="https://www.fencewithfun.com" target="_blank">
        <img src="/112/fr/static/_mobile/pg39.jpg">
      </a>
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale pointer 40-arrow" style="top:938px;left:1174px" onclick="Publish.goToNextPage()" src="/112/fr/static/_content/40-arrow.png">
      <img class="halfScale 40-title" style="top:126px;left:85px" src="/112/fr/static/_content/40-title.png">
      <img class="halfScale 40-logo" style="top:117px;left:1270px" src="/112/fr/static/_content/40-logo.png">
      <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      <div class="addContentLink" onclick="showOverlay('40-pop-1')" style="top:397px;left:155px;width:399px;height:36px"></div>
      <div class="addContentLink" onclick="showOverlay('40-pop-2')" style="top:981px;left:129px;width:399px;height:36px"></div>
      <div class="addContentLink" onclick="showOverlay('40-pop-3')" style="top:435px;left:1067px;width:370px;height:36px"></div>
      <div class="addContentLink" onclick="showOverlay('40-pop-4')" style="top:644px;left:1067px;width:370px;height:36px"></div>
      <div class="addContentLink" onclick="showOverlay('40-pop-5')" style="top:819px;left:1067px;width:370px;height:36px"></div>

      <div id="40-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/40-pop-bg.jpg">
        <img id="" class="halfScale" style="top:300px;left:81px;" src="/112/fr/static/_content/40-pop-1.png">

        <a href="https://youtu.be/UaKsXFM85hw" target="_blank">
          <svg class="abs pointer" style="bottom:195px;left:1012px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>

        <a href="https://tokyo2020.org/en/special/countdown/" target="_blank">
          <div class="contentLinkNone" style="top:850px;left:1230px;width:51px; height:51px;"></div>
        </a>

        <div class="addContentLink" style="top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0" onclick="hideOverlay('40-pop-1');"></div>
      </div>

      <div id="40-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/40-pop-bg.jpg">
        <img id="" class="halfScale" style="top:150px;left:81px;" src="/112/fr/static/_content/40-pop-2.png">
        <div class="addContentLink" style="top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0" onclick="hideOverlay('40-pop-2');"></div>
        
        <a href="https://fie.org/competitions" target="_blank">
          <div class="contentLinkNone" style="top:466px;left:1097px;width:34px; height:28px;"></div>
        </a>
        
        <a href="https://www.instagram.com/fencing_fie/?hl=en" target="_blank">
          <img class="halfScale" style="top:887px;left:779px" src="/112/fr/static/_content/ig-yel.png">
        </a>

        <a href="https://youtu.be/6oicUedEcAc" target="_blank">
          <svg class="abs pointer" style="bottom:485px;left:992px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>

        <a href="https://youtu.be/yWxegnMT-_o" target="_blank">
        <svg class="abs pointer" style="bottom:485px;left:1262px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg>
        </a>
      </div>

      <div id="40-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/40-pop-bg.jpg">
        <img id="" class="halfScale" style="top:199px;left:90px;" src="/112/fr/static/_content/40-pop-3.png">
        <div class="addContentLink" style="top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0" onclick="hideOverlay('40-pop-3');"></div>
        <a href="http://www.vultureday.org/" target="_blank">
          <div class="contentLinkNone" style="top:1057px;left:960px;width:216px; height:28px;"></div>
        </a>
      </div>

      <div id="40-pop-4" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/40-pop-bg.jpg">
        <img id="" class="halfScale" style="top:149px;left:126px;" src="/112/fr/static/_content/40-pop-4.png">
        <div class="addContentLink" style="top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0" onclick="hideOverlay('40-pop-4');"></div>
        <a href="https://www.cannescorporate.com/" target="_blank">
          <div class="contentLinkNone" style="top:858px;left:975px;width:39px; height:28px;"></div>
        </a>
      </div>

      <div id="40-pop-5" class="standardTransition contentOverlay hidden noclick">
        <img id="" class="halfScale" style="top:0px;left:0px" src="/112/fr/static/_content/40-pop-bg.jpg">
        <img id="" class="halfScale" style="top:138px;left:81px;" src="/112/fr/static/_content/40-pop-5.png">
        <div class="addContentLink" style="top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0" onclick="hideOverlay('40-pop-5');"></div>
      </div>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax()
          pg40Anim
            .fromTo(cOf("40-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            .fromTo(cOf("40-logo"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, "-=0.2")
            .fromTo(cOf("40-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, "-=0.2")
        }

        function onPageLeave() {
          pg40Anim.stop();
          hideOverlay('40-pop-1');
          hideOverlay('40-pop-2');
          hideOverlay('40-pop-3');
          hideOverlay('40-pop-4');
          hideOverlay('40-pop-5');
          removeContentLinks();
        }
      `,
      "searchText": "ACTUALITÉS  ACTUALITÉS DE LA FIE 1  Tokyo 2020 : plus qu'un an !  3  Cliquez ici pour en savoir plus  WWW.FIE.ORG  Le Botswana fête la Journée mondiale de l'escrime Cliquez ici pour en savoir plus  4  Une vidéo d'escrime de Budapest primée à Cannes Cliquez ici pour en savoir plus  5  Donate Your Fencing Gear! au Paraguay Cliquez ici pour en savoir plus  2  Le tournoi satellite d'escrime à Tachkent Cliquez ici pour en savoir plus  W W W.FIE .ORG",
      "mobileHtml":`
      

      <h2>Tokyo 2020 : plus qu'un an ! </h2>
      <p>À tout juste un an du début des Jeux Olympiques 2020 à Tokyo, les tireurs du monde entier attendent avec impatience de se plonger dans les activités, les qualifications et l'esprit des Jeux au cours des mois à venir. Lors des Championnats du monde d'escrime 2019 à Budapest, qui se sont terminés le 23 juillet, des athlètes internationaux fougueux et enthousiastes ont donné le coup d'envoi de l'année restante, ainsi qu'un aperçu de leurs attentes pour eux-mêmes, leurs équipes et le monde, à l'approche des Jeux Olympiques. </p>
      <p>La FIE et ses 153 fédérations membres collaborent et mènent ensemble un grand nombre d'activités pour soutenir les nombreuses initiatives du Comité d'organisation de Tokyo 2020, en particulier des projets impliquant et promouvant la durabilité environnementale dans le monde.</p>
      <p>Davantage d'informations officielles concernant le compte à rebours pour Tokyo 2020 sont disponibles <a href="https://tokyo2020.org/en/special/countdown/" target="_blank">ici</a>.</p>
      <p><a href="https://twitter.com/search?q=%231YearToGo&src=typed_query" target="_blank">#1YearToGo</a></p>

      <h2>Le tournoi satellite d'escrime à Tachkent</h2>
      <p>Des tireurs de 19 pays ont participé aux épreuves individuelles à l'épée et au fleuret du tournoi satellite de la FIE à Tachkent, à l'occasion duquel des réunions, des démonstrations d'escrime et des championnats régionaux ont également été organisés. Le tournoi satellite FIE Fleuret et Épée de Tachkent a attiré environ 120 tireurs et tireuses qui ont entamé avec enthousiasme leur saison de compétition 2019-2020.</p>
      <p>Le tournoi satellite, organisé du 5 au 8 septembre, a été suivi par les Championnats d'Asie centrale, les 9 et 10 septembre, qui comprenaient des épreuves aux trois armes. Des tireurs d'un grand nombre de pays d'Asie centrale et d'ailleurs étaient en lice, notamment des athlètes d'Afghanistan, de Russie, d'Azerbaïdjan, de Géorgie et de Malaisie. Parallèlement à la compétition, le Comité exécutif de la Confédération d'Asie centrale a organisé des réunions, axées en particulier sur le thème « En route vers Tokyo 2020 » et sur l'implication de l'organisation dans les prochains Jeux Olympiques d'été.</p>
      <p>Le Comité exécutif de la Confédération d'Asie centrale a indiqué que, l'année 2020 étant une année olympique, les prochains Championnats d'Asie centrale seraient élargis pour inclure les jeunes et les vétérans afin de promouvoir l'escrime au sein de groupes d'âges plus jeunes et plus âgés et de les faire participer davantage à l'effervescence qui entoure l'escrime olympique. Des épreuves de la semaine se sont déroulées le 7 septembre, Journée mondiale de l'escrime. À cette occasion, la Confédération a organisé des démonstrations d'escrime pour plus de 250 enfants dans plusieurs écoles de la région.</p>
      <p>Les résultats officiels du tournoi satellite FIE Fleuret et Épée de Tachkent sont disponibles <a href="https://fie.org/competitions" target="_blank">ici</a>.</p>
      <p> <a href="https://twitter.com/search?q=%231YearToGo&src=typed_query" target="_blank">#1YearToGo</a></p>

      
      
      
      <h2>Le Botswana fête la Journée mondiale de l'escrime </h2>
      <p>La BAFS (Botswana Amateur Fencing Society), en partenariat avec Young Africa Botswana et le KRC (Kalahari Research and Conservation), a célébré la Journée mondiale de l'escrime le samedi 7 septembre. Un certain nombre d'activités ont été organisées sur le thème « L'escrime pour notre planète », et la BAFS s'est également jointe à ses partenaires du KRC, du Département des affaires environnementales et de plusieurs autres organisations pour célébrer l'International Vulture Awareness Day (Journée internationale de sensibilisation aux vautours), qui se déroule à la même date annuelle officielle que la Journée mondiale de l'escrime. Les tireurs ont défilé dans la ville aux côtés de nombreux officiels du gouvernement et d'autres organismes, notamment des représentants du Ministère de l'Environnement, de la Conservation des ressources naturelles et du Tourisme, de plusieurs ambassades et d'autres organisations. Le maire de la ville de Gaborone et d'autres dignitaires étaient présents et se sont adressés au public au cours de l'événement.</p>
      <p>Après la marche de solidarité, la BAFS s'est rendue au Lady Olebile Masire Youth Centre, qui fait partie des installations du Young Africa Botswana, où un mini tournoi d'escrime et des démonstrations pour le public étaient organisés pour que chacun puisse découvrir « l'esprit de l'escrime en action », selon un communiqué officiel de la BAFS. « La BAFS encourage les athlètes, les entraîneurs, les clubs d'escrime et les fédérations du monde entier à montrer non seulement leur amour pour l'escrime, mais également à utiliser leurs talents et leur dévouement envers le sport pour contribuer à l'épanouissement de leurs communautés et améliorer notre environnement commun », a ajouté la BAFS. </p>
      <p>*Information sur la Journée internationale de sensibilsation aux vautours et sur le role important que jouent les vautours dans la biodiversité des environments où ils habitent sont disponibles sur <a href="https://www.vultureday.org" target="_blank">www.vultureday.org</a></p>
      
      <h2>Une vidéo d’escrime de Budapest primée à Cannes</h2>
      <p>Une vidéo produite à l’occasion des Championnats du monde d’escrime 2019 de Budapest a remporté le trophée du « Dauphin d’argent » lors du festival annuel Cannes Corporate Media & TV Awards. La vidéo, intitulée « A Kind of Magic », concourait dans la catégorie des Médias sociaux et courtes vidéos.</p>
      <p>Cette vidéo, courte et divertissante, a été diffusée au public de l’escrime dans le BOK Hall de Budapest, où les finales devaient se tenir. Elle met en scène le sabreur hongrois Andras Szatmari, champion du monde et personnage principal du film, qui doit faire face à un magicien lors d’un assaut d’escrime. M. Szatmari était présent pour recevoir la récompense, accompagnée du directeur du film, M. Ivan Vermes. Au total, 950 productions issues de 51 pays ont été soumises à la compétition internationale de Cannes afin de remporter l’un des 149 trophées : dauphin d’or, d’argent, noir ou bleu ou encore le tant convoité Grand Prix du « Dauphin Blanc ».</p>
      <p>Le festival Corporate Media & TV Awards de Cannes met chaque année à l’honneur les « les meilleurs films corporate, films destinés à un usage en ligne, documentaires et reportages ». Il s’agit du seul festival dédié au film corporate ayant lieu à Cannes, ville légendaire du long métrage et du film publicitaire. Cette compétition, qui fête ses dix ans, est ouverte aux producteurs de films, clients, agences, chaînes de télévision et étudiants. Des informations détaillées sur ces récompenses, y compris une liste complète des gagnants et des liens vers les films primés sont disponibles <a href="https://www.cannescorporate.com/" target="_blank">ici</a>.</p>
      <p>La FIE tient à féliciter M. Szatmari, M. Vermes et la Fédération hongroise d’escrime pour cette splendide réussite.</p>
      
      




      <h2>Donate Your Fencing Gear! au Paraguay</h2>
      <p>La Fédération paraguayenne d'escrime (FPE), qui fait partie des bénéficiaires de la saison d'escrime 2018-2019 du programme Donate Your Fencing Gear! de la FIE, a qualifié son année d'entraînement et de compétition de « succès » grâce, en partie, à l'utilisation des équipements reçus en don. L'objectif du programme de la FIE est de collecter auprès des tireurs de haut niveau des équipements d'escrime approuvés par la FIE qui sont usagés mais de bonne qualité, afin de soutenir les tireurs aguerris ou débutants vivant dans des milieux défavorisés aux quatre coins du monde, comme au Paraguay. </p>
      <p>L'un des critères du processus de candidature, la « motivation », a été décrit comme suit par la FPE et son chef de projet, Miguel Angel Paredes Fassino : offrir « des alternatives aux jeunes et aux enfants, garçons et filles, pour leur permettre de profiter de lieux publics comme les squares et les hébergements temporaires, tels que ceux accueillant les personnes touchées par les inondations provoquées par la rivière Río Paraguay, et du quartier d'Obrero de la ville d'Asunción ». Les autres objectifs cités étaient notamment de découvrir de nouveaux talents de l'escrime pour le Paraguay, d'être à même d'inscrire des athlètes aux Championnats d'Amérique du Sud (qui se sont déroulés en 2018), et de se préparer pour participer à la compétition d'escrime des Jeux d'Amérique du Sud (ODESUR 2022) qui seront accueillis à Asunción. La ville a également joué un rôle prépondérant en soutenant également la FPE, qui a réussi à faire participer plusieurs de ses athlètes à des compétitions de toute la région.</p>
      <p>Des entraînements d'escrime en extérieur ont notamment été organisés tout au long de l'année sur la Plaza Cerro Porteno de la ville de Fernando de la Mora et au Comando de Ingeniería de la ville d'Asunción, à proximité des zones inondées mentionnées précédemment. Grâce à l'enseignement des entraîneurs d'escrime, Alessandro Tradori et Juan Antonio Lucas, et aux bénéfices directs du programme Donate Your Fencing Gear!, des athlètes de régions spécifiques manquant de ressources et d'équipements ont pu s'entraîner régulièrement. Plusieurs enfants pratiquant l'escrime ont ainsi pu participer aux championnats nationaux, et remporter des médailles de bronze, d'argent et même d'or. Le Comité Olympique paraguayen a également apporté son soutien en affrétant des bus deux fois par semaine pour emmener les enfants aux entraînements. </p>
      <p>La FPE développe l'escrime et met actuellement en œuvre des projets similaires dans d'autres villes aux quatre coins du Paraguay. Aux dernières nouvelles, l'escrime avait fait ses premiers pas dans les villes de Villa Hayes, à 50 km d'Asunción, et de Villarrica, à 150 km.  </p>


      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
          <a href="https://absolutefencinggear.com" target="_blank">
            <div class="contentLinkNone" style="top:1022px;left:372px;width:484px; height:47px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml":`
        <a href="https://absolutefencinggear.com" target="_blank">
          <img src="/112/fr/static/_mobile/pg41.jpg">
        </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
          <a href="http://www.gfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:728px;left:545px;width:219px; height:28px;"></div>
          </a>

          <a href="mailto:sales@gfencing.com">
            <div class="contentLinkNone" style="top:728px;left:765px;width:219px; height:28px;"></div>
          </a>
          `,
      "script": `
        function onPageEnter() {
          setTimeout(function() {
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "",
      "mobileHtml":`
        <a href="http://www.gfencing.com" target="_blank">
          <img src="/112/fr/static/_mobile/pg42.jpg">
        </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `
      <img id="43-title" class="halfScale" style="top:50px;left:83px" src="/112/fr/static/_content/43-title.png">

      <img id="43-pop-1" class="halfScale 43-pop" style="top:390px;left:84px;" src="/112/fr/static/_content/43-pop-1.png">
      <img id="43-pop-2" class="halfScale 43-pop" style="top:390px;left:84px;opacity:0" src="/112/fr/static/_content/43-pop-2.png">
      <img id="43-pop-3" class="halfScale 43-pop" style="top:390px;left:84px;opacity:0" src="/112/fr/static/_content/43-pop-3.png">
      
      <img class="halfScale pointer 43-btn" id="43-btn-1" style="top:454px;left:1135px;" onclick="pg43Toggle('43-pop-1', '43-btn-1');" src="/112/fr/static/_content/43-btn-1.png">
      <img class="halfScale pointer 43-btn" id="43-btn-2" style="top:595px;left:1135px;opacity:0" onclick="pg43Toggle('43-pop-2', '43-btn-2');" src="/112/fr/static/_content/43-btn-2.png">
      <img class="halfScale pointer 43-btn" id="43-btn-3" style="top:730px;left:1135px;opacity:0" onclick="pg43Toggle('43-pop-3', '43-btn-3');" src="/112/fr/static/_content/43-btn-3.png">

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        pg43Anim = new TimelineMax()
        pg43Anim
          .fromTo(idOf("43-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1, onComplete: addContentLinks},0.5)
      }

      function pg43Toggle(id, btn) {
        var ele = idOf(id)
        var but = idOf(btn)
        TweenMax.to(cOf("43-pop"), 0.1, {opacity: 0});
        TweenMax.to(cOf("43-btn"), 0.1, {opacity: 0});
        TweenMax.to(ele, 0.1, {opacity: 1});
        TweenMax.to(but, 0.1, {opacity: 1});
      }

      function onPageLeave() {
        pg43Anim.stop();
        pg43Toggle("43-pop-1", "43-btn-1");
        removeContentLinks();
      }
      `,
      "searchText": "NÉCROLO GIE  NÉCROLOGIES GREGORIO LIMA (PUR) C’est avec une grande tristesse que la FIE vous fait part du décès de Gregorio Lima ce 25 juillet à San Juan, Porto Rico, à l’âge de 80 ans. M. Lima était membre du Conseil des vétérans de la FIE depuis 2016. Membre de la Fédération portoricaine d’escrime depuis 1980, il y a assumé les fonctions de vice-président pendant 25 ans et de président de 2010 à 2017. Il était avocat de profession et titulaire d’un doctorat en droit. La FIE et la famille mondiale de l’escrime ont perdu l’un de leurs membres, apprécié et respecté de tous. M. Lima n’a jamais cessé de donner le meilleur  de lui-même, consacrant toute son énergie à la cause de notre sport. Leader extraordinaire, il a fortement contribué au développement de l’escrime. Nous présentons nos plus sincères condoléances à sa famille et à ses amis, ainsi qu’à la Fédération portoricaine d’escrime, et nous les assurons de notre profonde sympathie dans ces moments difficiles. ■  GREGORIO LIMA  SHLOMI EYAL  UWE NEDER  s Cliquez ici  W W W.FIE .ORG",
      "mobileHtml":`
      
      
      
      
      
      L'arbitre allemand Uwe Neder est décédé subitement fin octobre à l'âge de 54 ans. 

      Neder a découvert l'escrime en tant que « père d'escrimeuses », puisqu'il amenait ses filles aux entraînements et aux compétitions. Il a rapidement souhaité s'impliquer davantage et a commencé en 2001 sa formation d'arbitre. Neder est devenu un arbitre accompli à la fois au niveau national et international, et a notamment officié lors des Jeux Mondiaux Militaires 2015 en Corée du Sud, sa compétition la plus importante. En 2016, il a été élu « Arbitre à l'épée de l'année » par la Fédération allemande d'escrime.
      Au-delà de l'arbitrage, Neder était très impliqué dans le club d'escrime de sa ville, le FC Offenbach, notamment en tant qu'organisateur de tournois. 
      
      Cette personnalité amicale et charismatique de l'escrime va manquer à tous les membres de son club, mais également aux communautés de l'escrime allemande et internationale.
      
      

      

      <p><strong>Gregorio Lima (PUR)</strong></p>
      <p>C'est avec une grande tristesse que la FIE vous fait part du décès de Gregorio Lima ce 25 juillet à San Juan, Porto Rico, à l'âge de 80 ans. </p>
      <p>M. Lima était membre du Conseil des vétérans de la FIE depuis 2016. Membre de la Fédération portoricaine d'escrime depuis 1980, il y a assumé les fonctions de vice-président pendant 25 ans et de président de 2010 à 2017. Il était avocat de profession et titulaire d'un doctorat en droit. </p>
      <p>La FIE et la famille mondiale de l'escrime ont perdu l'un de leurs membres, apprécié et respecté de tous. M. Lima n'a jamais cessé de donner le meilleur de lui-même, consacrant toute son énergie à la cause de notre sport. Leader extraordinaire, il a fortement contribué au développement de l'escrime. </p>
      <p>Nous présentons nos plus sincères condoléances à sa famille et à ses amis, ainsi qu'à la Fédération portoricaine d'escrime, et nous les assurons de notre profonde sympathie dans ces moments difficiles. </p>

      <p><strong>Shlomi Eyal (ISR)</strong></p>
      <p>La FIE a la tristesse de vous faire part du décès de M. Shlomi Eyal, né le 20 juin 1959. M. Eyal a représenté Israël aux Jeux Olympiques en 1984, et est ensuite devenu entraîneur aux États-Unis. En 1988, il est revenu en Israël où il a créé un club d'escrime au kibboutz Yizrael. Au cours de ses nombreuses années consacrées à l'escrime, il a formé plusieurs athlètes d'élite et a assumé la fonction d'entraîneur national. </p>
      <p>Au nom de la famille mondiale de l'escrime, la FIE présente ses plus sincères condoléances à sa famille, à ses amis et à la Fédération israélienne d'escrime.</p>

      <p><strong>Uwe Neder (GER)</strong></p>
      <p>L'arbitre allemand Uwe Neder est décédé subitement fin octobre à l'âge de 54 ans. </p>
      <p>Neder a découvert l'escrime en tant que « père d'escrimeuses », puisqu'il amenait ses filles aux entraînements et aux compétitions. Il a rapidement souhaité s'impliquer davantage et a commencé en 2001 sa formation d'arbitre. Neder est devenu un arbitre accompli à la fois au niveau national et international, et a notamment officié lors des Jeux Mondiaux Militaires 2015 en Corée du Sud, sa compétition la plus importante. En 2016, il a été élu « Arbitre à l'épée de l'année » par la Fédération allemande d'escrime.</p>
      <p>Au-delà de l'arbitrage, Neder était très impliqué dans le club d'escrime de sa ville, le FC Offenbach, notamment en tant qu'organisateur de tournois. </p>
      <p> Cette personnalité amicale et charismatique de l'escrime va manquer à tous les membres de son club, mais également aux communautés de l'escrime allemande et internationale.</p>

      `
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function toggleCategory(id, klass) {
        var category = idOf(id);
        console.log(category)
        var categories = cOf(klass);
        console.log(categories)
        for(i=0; i < categories.length; i++){
          categories[i].style.opacity = 0;
        }
        category.style.opacity = 1;
      }
    `,
    "mobilePages":  [
      {
        "title": "Escrime XXI No. 112",
        "cssClass": "cover mobile-p1",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 0,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 2,
          "subIndex": 0
        }]
      },
      {
        "title": "Comex",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 4,
          "subIndex": 0
        }]
      },
      {
        "title": "Sommaire",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 5,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 6,
          "subIndex": 0
        }]
      },
      {
        "title": "Championnats du monde d'escrime vétérans",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 7,
            "subIndex": 0
          },
          {
            "index": 8,
            "subIndex": 0
          },
          {
            "index": 9,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "IWAS",
        "cssClass": "red",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 10,
            "subIndex": 0
          },
          {
            "index": 11,
            "subIndex": 0
          },
          {
            "index": 12,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 13,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 14,
          "subIndex": 0
        }]
      },
      {
        "title": "À LA RENCONTRE DES SPORTIFS: Sofia Velikaya",
        "cssClass": "aqua",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 15,
            "subIndex": 0
          },
          {
            "index": 16,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 17,
          "subIndex": 0
        }]
      },
      {
        "title": "Journée mondiale de l'escrime",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 18,
            "subIndex": 0
          },
          {
            "index": 19,
            "subIndex": 0
          },
          {
            "index": 20,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 21,
          "subIndex": 0
        }]
      },
      {
        "title": "Journée mondiale de l'escrime - Siège social de la FIE",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 22,
            "subIndex": 0
          },
          {
            "index": 23,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 24,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 25,
          "subIndex": 0
        }]
      },
      {
        "title": "Jeux Panaméricains",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 26,
            "subIndex": 0
          },
          {
            "index": 27,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 28,
          "subIndex": 0
        }]
      },
      {
        "title": "La ville de Guatemala célèbre la Journée mondiale de l'escrime",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 29,
            "subIndex": 0
          },
          {
            "index": 30,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 31,
          "subIndex": 0
        }]
      },
      {
        "title": "CAMP D’ENTRAINEMENT DE LA FIE A BUDAPEST",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
          "index": 32,
          "subIndex": 0
        },
        {
          "index": 33,
          "subIndex": 0
        },]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 34,
          "subIndex": 0
        }]
      },
      {
        "title": "Solidarité Olympique - Cours pour entraîneurs",
        "cssClass": "green",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 35,
            "subIndex": 0
          },
          {
            "index": 36,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 37,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 38,
          "subIndex": 0
        }]
      },
      {
        "title": "FIE ACTUALITÉS",
        "cssClass": "yellow",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 39,
            "subIndex": 0
          },
        ]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 40,
          "subIndex": 0
        }]
      },
      {
        "title": "Advert",
        "cssClass": "advert",
        "hideInMenu": true,
        "pageLinks": [{
          "index": 41,
          "subIndex": 0
        }]
      },
      {
        "title": "Nécrologie",
        "cssClass": "grey",
        "hideInMenu": false,
        "pageLinks": [{
            "index": 42,
            "subIndex": 0
          },
        ]
      },
    ],
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js